// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  queryOptions,
  type UseMutationOptions,
} from '@tanstack/react-query';

import { client } from '../client.gen';
import {
  documentIsReady,
  glacierAgenciesApiListWritingCompany,
  glacierAssistantApiAssistantConfig,
  glacierAssistantApiChat,
  glacierAssistantApiSubmitFeedback,
  glacierAuthenticationApiMfaVerify,
  glacierNewGradApiDownloadPolicy,
  glacierNewGradApiDownloadQuote,
  glacierNewGradApiGetAnswers,
  glacierNewGradApiIssuePolicy,
  glacierNewGradApiMarkPaymentAsPaid,
  glacierNewGradApiPollPayment,
  glacierNewGradApiSaveAnswers,
  glacierNewGradApiValidateAgency,
  glacierNewGradApiValidateAssociationCode,
  glacierOneschemaApiBulkUploadDentists,
  glacierOneschemaApiBulkUploadLocations,
  glacierOneschemaApiBulkUploadPolicies,
  glacierOneschemaApiGetJwtToken,
  glacierPolicyApiAcknowledgePolicyAlert,
  glacierPolicyApiAddCommercialPropertyCoverage,
  glacierPolicyApiAddDentist,
  glacierPolicyApiAddLocation,
  glacierPolicyApiAgencyBillInvoice,
  glacierPolicyApiAssign,
  glacierPolicyApiAssignable,
  glacierPolicyApiAssignAgent,
  glacierPolicyApiAssignUnderwriter,
  glacierPolicyApiBulkUpdateLocations,
  glacierPolicyApiCancelMidtermChange,
  glacierPolicyApiChangeEndorsementEffectiveDate,
  glacierPolicyApiClearDentistTruthmd,
  glacierPolicyApiCloseRenewal,
  glacierPolicyApiCommitTransactionTest,
  glacierPolicyApiConditionalRenewalNotice,
  glacierPolicyApiConfirmRatingChecks,
  glacierPolicyApiCreateMidtermTransaction,
  glacierPolicyApiCreateOwnedEntities,
  glacierPolicyApiCreatePolicy,
  glacierPolicyApiCreatePolicyPendingCancellationTransaction,
  glacierPolicyApiCreateRenewal,
  glacierPolicyApiCreateUnderwriterNotes,
  glacierPolicyApiDeclineTransaction,
  glacierPolicyApiDeleteCommercialPropertyCoverage,
  glacierPolicyApiDeleteDentist,
  glacierPolicyApiDeleteLocation,
  glacierPolicyApiDeleteOwnedEntity,
  glacierPolicyApiDeletePolicyRenewalFlag,
  glacierPolicyApiDeletePrintQueue,
  glacierPolicyApiDeleteUnderwriterNotes,
  glacierPolicyApiDetachDocument,
  glacierPolicyApiDiscardTransaction,
  glacierPolicyApiDownloadAllTransactionsDocuments,
  glacierPolicyApiDownloadDocument,
  glacierPolicyApiDownloadErpWorksheets,
  glacierPolicyApiDownloadLookerDashboardCsv,
  glacierPolicyApiDownloadLookerDashboardPdf,
  glacierPolicyApiDownloadRatingWorksheets,
  glacierPolicyApiFinalizeMidtermChange,
  glacierPolicyApiGetAgentAuthority,
  glacierPolicyApiGetChildPolicy,
  glacierPolicyApiGetCommercialPropertyCoverage,
  glacierPolicyApiGetCommercialPropertyLocation,
  glacierPolicyApiGetCyberLiability,
  glacierPolicyApiGetDentist,
  glacierPolicyApiGetDentistInformation,
  glacierPolicyApiGetDentistPricing,
  glacierPolicyApiGetDentistProcedures,
  glacierPolicyApiGetFormulas,
  glacierPolicyApiGetLatestTransactionLatestAttempt,
  glacierPolicyApiGetLatestTransactionSummary,
  glacierPolicyApiGetLocation,
  glacierPolicyApiGetObjectDetails,
  glacierPolicyApiGetOwnedEntity,
  glacierPolicyApiGetPlCoverage,
  glacierPolicyApiGetPolicy,
  glacierPolicyApiGetPolicyAlerts,
  glacierPolicyApiGetPolicyDetails,
  glacierPolicyApiGetPolicyPermissions,
  glacierPolicyApiGetPolicySummary,
  glacierPolicyApiGetPolicySummarySearch,
  glacierPolicyApiGetPolicyTerms,
  glacierPolicyApiGetPolicyWithSummaries,
  glacierPolicyApiGetPracticeOwners,
  glacierPolicyApiGetPrintQueue,
  glacierPolicyApiGetSpecialForms,
  glacierPolicyApiGetSummaryOfChangesPdf,
  glacierPolicyApiGetTransactionDetail,
  glacierPolicyApiGetTransactionSummary,
  glacierPolicyApiIssuePolicy,
  glacierPolicyApiListDocuments,
  glacierPolicyApiListObjectSummaries,
  glacierPolicyApiListPolicies,
  glacierPolicyApiListTransactions,
  glacierPolicyApiListUnderwriterNotes,
  glacierPolicyApiPremiumRenewalNotice,
  glacierPolicyApiPremiumStatement,
  glacierPolicyApiPricePreviewMidtermChange,
  glacierPolicyApiPrintQueue,
  glacierPolicyApiRatePolicy,
  glacierPolicyApiReasonForChangePreview,
  glacierPolicyApiReferPolicy,
  glacierPolicyApiRefreshCommercialPropertyWithCorelogic,
  glacierPolicyApiRefreshCommercialPropertyWithVerisk,
  glacierPolicyApiRegenerateCompletePolicyBundle,
  glacierPolicyApiRegenerateDocument,
  glacierPolicyApiRenewalSummaryOfChanges,
  glacierPolicyApiReopenTransaction,
  glacierPolicyApiReopenUnlockedAccount,
  glacierPolicyApiRevertTransaction,
  glacierPolicyApiSaveDentistTruthmd,
  glacierPolicyApiSearchTruthmdData,
  glacierPolicyApiSetDentistAsFirstNamedInsured,
  glacierPolicyApiSetOwnedEntityAsFirstNamedInsured,
  glacierPolicyApiSetPolicyRenewalFlag,
  glacierPolicyApiSetReasonForChange,
  glacierPolicyApiSpecimenPreview,
  glacierPolicyApiStartChangeExpirationDateMidterm,
  glacierPolicyApiUndoDeleteCommercialPropertyCoverage,
  glacierPolicyApiUndoDeleteDentist,
  glacierPolicyApiUndoDeleteLocation,
  glacierPolicyApiUndoDeleteOwnedEntity,
  glacierPolicyApiUpdateBasicDentist,
  glacierPolicyApiUpdateBypassValidators,
  glacierPolicyApiUpdateCommercialPropertyCoverage,
  glacierPolicyApiUpdateCpCoverage,
  glacierPolicyApiUpdateCyberLiability,
  glacierPolicyApiUpdateDentistInformation,
  glacierPolicyApiUpdateDentistPricing,
  glacierPolicyApiUpdateDentistProcedures,
  glacierPolicyApiUpdateDentistUnderwritingQuestions,
  glacierPolicyApiUpdateDocument,
  glacierPolicyApiUpdatedOwnedEntity,
  glacierPolicyApiUpdateEmploymentPracticesLiability,
  glacierPolicyApiUpdateErisaAndEmployeeBenefits,
  glacierPolicyApiUpdateGeneralLiability,
  glacierPolicyApiUpdateLocation,
  glacierPolicyApiUpdatePlCoverage,
  glacierPolicyApiUpdatePlPracticeOwner,
  glacierPolicyApiUpdatePolicyDetails,
  glacierPolicyApiUpdatePrimaryLocation,
  glacierPolicyApiUpdateUnderwriterNotes,
  glacierPolicyApiUploadDocument,
  glacierPolicyApiUploadDocumentsWithMetadata,
  glacierPolicyCloneApiCopyPolicyEndpoint,
  glacierPolicyConditionsApiCreateBindingCondition,
  glacierPolicyConditionsApiCreateTermsCondition,
  glacierPolicyConditionsApiDeleteBindingCondition,
  glacierPolicyConditionsApiDeleteTermsCondition,
  glacierPolicyConditionsApiListBindingConditions,
  glacierPolicyConditionsApiListTermsConditions,
  glacierPolicyConditionsApiUpdateBindingCondition,
  glacierPolicyConditionsApiUpdateTermsCondition,
  glacierPolicyErpApiGetErpEligibleDates,
  glacierPolicyErpApiGetErpSections,
  glacierPolicyErpApiSaveErpSelections,
  glacierPolicyErpApiStartErpEndorsement,
  glacierPolicyFormsApiAttachFormToDentist,
  glacierPolicyFormsApiAttachFormToEntity,
  glacierPolicyFormsApiAttachFormToLocation,
  glacierPolicyFormsApiAttachFormToPolicy,
  glacierPolicyFormsApiDetachFormFromDentist,
  glacierPolicyFormsApiDetachFormFromEntity,
  glacierPolicyFormsApiDetachFormFromLocation,
  glacierPolicyFormsApiDetachFormFromPolicy,
  glacierPolicyFormsApiGetAvailableEndorsements,
  glacierPolicyFormsApiGetDentistAttachedForms,
  glacierPolicyFormsApiGetDentistAvailableEndorsements,
  glacierPolicyFormsApiGetEntityAttachedForms,
  glacierPolicyFormsApiGetEntityAvailableEndorsements,
  glacierPolicyFormsApiGetLocationAttachedForms,
  glacierPolicyFormsApiGetLocationAvailableEndorsements,
  glacierPolicyFormsApiGetQuestionsByDentist,
  glacierPolicyFormsApiGetQuestionsByEntity,
  glacierPolicyFormsApiGetQuestionsByLocation,
  glacierPolicyFormsApiGetQuestionsByPolicy,
  glacierPolicyFormsApiPolicyLevelAttachedEndorsements,
  glacierPolicyFormsApiPostSaveQuestionsAnswersDentist,
  glacierPolicyFormsApiPostSaveQuestionsAnswersEntity,
  glacierPolicyFormsApiPostSaveQuestionsAnswersLocation,
  glacierPolicyFormsApiPostSaveQuestionsAnswersPolicy,
  glacierPolicyFormsApiRenderForm,
  glacierUsersApiCurrentUser,
  glacierUsersApiForgotPasswordEndpoint,
  glacierUsersApiListUsers,
  glacierUsersApiRelatedUsers,
  glacierUsersApiResetPasswordEndpoint,
  glacierUsersApiUnderwriters,
  glacierUsersFeatureFlagsApiGetFeatureFlags,
  type Options,
} from '../sdk.gen';
import type {
  DocumentIsReadyData,
  DocumentIsReadyError,
  DocumentIsReadyResponse,
  GlacierAgenciesApiListWritingCompanyData,
  GlacierAgenciesApiListWritingCompanyResponse,
  GlacierAssistantApiAssistantConfigData,
  GlacierAssistantApiAssistantConfigResponse,
  GlacierAssistantApiChatData,
  GlacierAssistantApiChatResponse,
  GlacierAssistantApiSubmitFeedbackData,
  GlacierAssistantApiSubmitFeedbackResponse,
  GlacierAuthenticationApiMfaVerifyData,
  GlacierAuthenticationApiMfaVerifyResponse,
  GlacierNewGradApiDownloadPolicyData,
  GlacierNewGradApiDownloadPolicyResponse,
  GlacierNewGradApiDownloadQuoteData,
  GlacierNewGradApiDownloadQuoteResponse,
  GlacierNewGradApiGetAnswersData,
  GlacierNewGradApiGetAnswersResponse,
  GlacierNewGradApiIssuePolicyData,
  GlacierNewGradApiIssuePolicyError,
  GlacierNewGradApiIssuePolicyResponse,
  GlacierNewGradApiMarkPaymentAsPaidData,
  GlacierNewGradApiMarkPaymentAsPaidResponse,
  GlacierNewGradApiPollPaymentData,
  GlacierNewGradApiPollPaymentResponse,
  GlacierNewGradApiSaveAnswersData,
  GlacierNewGradApiSaveAnswersError,
  GlacierNewGradApiSaveAnswersResponse,
  GlacierNewGradApiValidateAgencyData,
  GlacierNewGradApiValidateAgencyError,
  GlacierNewGradApiValidateAgencyResponse,
  GlacierNewGradApiValidateAssociationCodeData,
  GlacierNewGradApiValidateAssociationCodeError,
  GlacierNewGradApiValidateAssociationCodeResponse,
  GlacierOneschemaApiBulkUploadDentistsData,
  GlacierOneschemaApiBulkUploadDentistsError,
  GlacierOneschemaApiBulkUploadDentistsResponse,
  GlacierOneschemaApiBulkUploadLocationsData,
  GlacierOneschemaApiBulkUploadLocationsError,
  GlacierOneschemaApiBulkUploadLocationsResponse,
  GlacierOneschemaApiBulkUploadPoliciesData,
  GlacierOneschemaApiBulkUploadPoliciesError,
  GlacierOneschemaApiBulkUploadPoliciesResponse,
  GlacierOneschemaApiGetJwtTokenData,
  GlacierOneschemaApiGetJwtTokenError,
  GlacierOneschemaApiGetJwtTokenResponse,
  GlacierPolicyApiAcknowledgePolicyAlertData,
  GlacierPolicyApiAddCommercialPropertyCoverageData,
  GlacierPolicyApiAddCommercialPropertyCoverageResponse,
  GlacierPolicyApiAddDentistData,
  GlacierPolicyApiAddDentistResponse,
  GlacierPolicyApiAddLocationData,
  GlacierPolicyApiAddLocationResponse,
  GlacierPolicyApiAgencyBillInvoiceData,
  GlacierPolicyApiAgencyBillInvoiceResponse,
  GlacierPolicyApiAssignableData,
  GlacierPolicyApiAssignableResponse,
  GlacierPolicyApiAssignAgentData,
  GlacierPolicyApiAssignData,
  GlacierPolicyApiAssignUnderwriterData,
  GlacierPolicyApiBulkUpdateLocationsData,
  GlacierPolicyApiBulkUpdateLocationsResponse,
  GlacierPolicyApiCancelMidtermChangeData,
  GlacierPolicyApiCancelMidtermChangeResponse,
  GlacierPolicyApiChangeEndorsementEffectiveDateData,
  GlacierPolicyApiChangeEndorsementEffectiveDateResponse,
  GlacierPolicyApiClearDentistTruthmdData,
  GlacierPolicyApiClearDentistTruthmdResponse,
  GlacierPolicyApiCloseRenewalData,
  GlacierPolicyApiCommitTransactionTestData,
  GlacierPolicyApiConditionalRenewalNoticeData,
  GlacierPolicyApiConditionalRenewalNoticeResponse,
  GlacierPolicyApiConfirmRatingChecksData,
  GlacierPolicyApiConfirmRatingChecksResponse,
  GlacierPolicyApiCreateMidtermTransactionData,
  GlacierPolicyApiCreateMidtermTransactionResponse,
  GlacierPolicyApiCreateOwnedEntitiesData,
  GlacierPolicyApiCreateOwnedEntitiesResponse,
  GlacierPolicyApiCreatePolicyData,
  GlacierPolicyApiCreatePolicyPendingCancellationTransactionData,
  GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponse,
  GlacierPolicyApiCreatePolicyResponse,
  GlacierPolicyApiCreateRenewalData,
  GlacierPolicyApiCreateUnderwriterNotesData,
  GlacierPolicyApiCreateUnderwriterNotesResponse,
  GlacierPolicyApiDeclineTransactionData,
  GlacierPolicyApiDeclineTransactionError,
  GlacierPolicyApiDeclineTransactionResponse,
  GlacierPolicyApiDeleteCommercialPropertyCoverageData,
  GlacierPolicyApiDeleteCommercialPropertyCoverageResponse,
  GlacierPolicyApiDeleteDentistData,
  GlacierPolicyApiDeleteDentistResponse,
  GlacierPolicyApiDeleteLocationData,
  GlacierPolicyApiDeleteOwnedEntityData,
  GlacierPolicyApiDeleteOwnedEntityResponse,
  GlacierPolicyApiDeletePolicyRenewalFlagData,
  GlacierPolicyApiDeletePolicyRenewalFlagResponse,
  GlacierPolicyApiDeletePrintQueueData,
  GlacierPolicyApiDeleteUnderwriterNotesData,
  GlacierPolicyApiDeleteUnderwriterNotesResponse,
  GlacierPolicyApiDetachDocumentData,
  GlacierPolicyApiDiscardTransactionData,
  GlacierPolicyApiDiscardTransactionError,
  GlacierPolicyApiDiscardTransactionResponse,
  GlacierPolicyApiDownloadAllTransactionsDocumentsData,
  GlacierPolicyApiDownloadAllTransactionsDocumentsResponse,
  GlacierPolicyApiDownloadDocumentData,
  GlacierPolicyApiDownloadDocumentResponse,
  GlacierPolicyApiDownloadErpWorksheetsData,
  GlacierPolicyApiDownloadErpWorksheetsResponse,
  GlacierPolicyApiDownloadLookerDashboardCsvData,
  GlacierPolicyApiDownloadLookerDashboardCsvResponse,
  GlacierPolicyApiDownloadLookerDashboardPdfData,
  GlacierPolicyApiDownloadLookerDashboardPdfResponse,
  GlacierPolicyApiDownloadRatingWorksheetsData,
  GlacierPolicyApiDownloadRatingWorksheetsResponse,
  GlacierPolicyApiFinalizeMidtermChangeData,
  GlacierPolicyApiFinalizeMidtermChangeResponse,
  GlacierPolicyApiGetAgentAuthorityData,
  GlacierPolicyApiGetAgentAuthorityResponse,
  GlacierPolicyApiGetChildPolicyData,
  GlacierPolicyApiGetChildPolicyResponse,
  GlacierPolicyApiGetCommercialPropertyCoverageData,
  GlacierPolicyApiGetCommercialPropertyCoverageResponse,
  GlacierPolicyApiGetCommercialPropertyLocationData,
  GlacierPolicyApiGetCommercialPropertyLocationResponse,
  GlacierPolicyApiGetCyberLiabilityData,
  GlacierPolicyApiGetCyberLiabilityResponse,
  GlacierPolicyApiGetDentistData,
  GlacierPolicyApiGetDentistInformationData,
  GlacierPolicyApiGetDentistInformationResponse,
  GlacierPolicyApiGetDentistPricingData,
  GlacierPolicyApiGetDentistPricingResponse,
  GlacierPolicyApiGetDentistProceduresData,
  GlacierPolicyApiGetDentistProceduresResponse,
  GlacierPolicyApiGetDentistResponse,
  GlacierPolicyApiGetFormulasData,
  GlacierPolicyApiGetFormulasResponse,
  GlacierPolicyApiGetLatestTransactionLatestAttemptData,
  GlacierPolicyApiGetLatestTransactionLatestAttemptResponse,
  GlacierPolicyApiGetLatestTransactionSummaryData,
  GlacierPolicyApiGetLatestTransactionSummaryResponse,
  GlacierPolicyApiGetLocationData,
  GlacierPolicyApiGetLocationResponse,
  GlacierPolicyApiGetObjectDetailsData,
  GlacierPolicyApiGetObjectDetailsResponse,
  GlacierPolicyApiGetOwnedEntityData,
  GlacierPolicyApiGetOwnedEntityResponse,
  GlacierPolicyApiGetPlCoverageData,
  GlacierPolicyApiGetPlCoverageResponse,
  GlacierPolicyApiGetPolicyAlertsData,
  GlacierPolicyApiGetPolicyAlertsResponse,
  GlacierPolicyApiGetPolicyData,
  GlacierPolicyApiGetPolicyDetailsData,
  GlacierPolicyApiGetPolicyDetailsResponse,
  GlacierPolicyApiGetPolicyPermissionsData,
  GlacierPolicyApiGetPolicyPermissionsResponse,
  GlacierPolicyApiGetPolicyResponse,
  GlacierPolicyApiGetPolicySummaryData,
  GlacierPolicyApiGetPolicySummaryResponse,
  GlacierPolicyApiGetPolicySummarySearchData,
  GlacierPolicyApiGetPolicySummarySearchResponse,
  GlacierPolicyApiGetPolicyTermsData,
  GlacierPolicyApiGetPolicyTermsResponse,
  GlacierPolicyApiGetPolicyWithSummariesData,
  GlacierPolicyApiGetPolicyWithSummariesResponse,
  GlacierPolicyApiGetPracticeOwnersData,
  GlacierPolicyApiGetPracticeOwnersResponse,
  GlacierPolicyApiGetPrintQueueData,
  GlacierPolicyApiGetPrintQueueResponse,
  GlacierPolicyApiGetSpecialFormsData,
  GlacierPolicyApiGetSpecialFormsResponse,
  GlacierPolicyApiGetSummaryOfChangesPdfData,
  GlacierPolicyApiGetTransactionDetailData,
  GlacierPolicyApiGetTransactionDetailResponse,
  GlacierPolicyApiGetTransactionSummaryData,
  GlacierPolicyApiGetTransactionSummaryResponse,
  GlacierPolicyApiIssuePolicyData,
  GlacierPolicyApiListDocumentsData,
  GlacierPolicyApiListDocumentsResponse,
  GlacierPolicyApiListObjectSummariesData,
  GlacierPolicyApiListObjectSummariesResponse,
  GlacierPolicyApiListPoliciesData,
  GlacierPolicyApiListPoliciesResponse,
  GlacierPolicyApiListTransactionsData,
  GlacierPolicyApiListTransactionsResponse,
  GlacierPolicyApiListUnderwriterNotesData,
  GlacierPolicyApiListUnderwriterNotesResponse,
  GlacierPolicyApiPremiumRenewalNoticeData,
  GlacierPolicyApiPremiumRenewalNoticeResponse,
  GlacierPolicyApiPremiumStatementData,
  GlacierPolicyApiPremiumStatementResponse,
  GlacierPolicyApiPricePreviewMidtermChangeData,
  GlacierPolicyApiPricePreviewMidtermChangeResponse,
  GlacierPolicyApiPrintQueueData,
  GlacierPolicyApiPrintQueueResponse,
  GlacierPolicyApiRatePolicyData,
  GlacierPolicyApiRatePolicyError,
  GlacierPolicyApiRatePolicyResponse,
  GlacierPolicyApiReasonForChangePreviewData,
  GlacierPolicyApiReasonForChangePreviewResponse,
  GlacierPolicyApiReferPolicyData,
  GlacierPolicyApiReferPolicyError,
  GlacierPolicyApiReferPolicyResponse,
  GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData,
  GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponse,
  GlacierPolicyApiRefreshCommercialPropertyWithVeriskData,
  GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponse,
  GlacierPolicyApiRegenerateCompletePolicyBundleData,
  GlacierPolicyApiRegenerateCompletePolicyBundleResponse,
  GlacierPolicyApiRegenerateDocumentData,
  GlacierPolicyApiRenewalSummaryOfChangesData,
  GlacierPolicyApiReopenTransactionData,
  GlacierPolicyApiReopenTransactionError,
  GlacierPolicyApiReopenTransactionResponse,
  GlacierPolicyApiReopenUnlockedAccountData,
  GlacierPolicyApiReopenUnlockedAccountError,
  GlacierPolicyApiReopenUnlockedAccountResponse,
  GlacierPolicyApiRevertTransactionData,
  GlacierPolicyApiRevertTransactionResponse,
  GlacierPolicyApiSaveDentistTruthmdData,
  GlacierPolicyApiSaveDentistTruthmdResponse,
  GlacierPolicyApiSearchTruthmdDataData,
  GlacierPolicyApiSearchTruthmdDataResponse,
  GlacierPolicyApiSetDentistAsFirstNamedInsuredData,
  GlacierPolicyApiSetDentistAsFirstNamedInsuredResponse,
  GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredData,
  GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredResponse,
  GlacierPolicyApiSetPolicyRenewalFlagData,
  GlacierPolicyApiSetPolicyRenewalFlagResponse,
  GlacierPolicyApiSetReasonForChangeData,
  GlacierPolicyApiSetReasonForChangeResponse,
  GlacierPolicyApiSpecimenPreviewData,
  GlacierPolicyApiSpecimenPreviewResponse,
  GlacierPolicyApiStartChangeExpirationDateMidtermData,
  GlacierPolicyApiStartChangeExpirationDateMidtermResponse,
  GlacierPolicyApiUndoDeleteCommercialPropertyCoverageData,
  GlacierPolicyApiUndoDeleteCommercialPropertyCoverageResponse,
  GlacierPolicyApiUndoDeleteDentistData,
  GlacierPolicyApiUndoDeleteDentistResponse,
  GlacierPolicyApiUndoDeleteLocationData,
  GlacierPolicyApiUndoDeleteOwnedEntityData,
  GlacierPolicyApiUndoDeleteOwnedEntityResponse,
  GlacierPolicyApiUpdateBasicDentistData,
  GlacierPolicyApiUpdateBasicDentistResponse,
  GlacierPolicyApiUpdateBypassValidatorsData,
  GlacierPolicyApiUpdateBypassValidatorsResponse,
  GlacierPolicyApiUpdateCommercialPropertyCoverageData,
  GlacierPolicyApiUpdateCommercialPropertyCoverageResponse,
  GlacierPolicyApiUpdateCpCoverageData,
  GlacierPolicyApiUpdateCpCoverageResponse,
  GlacierPolicyApiUpdateCyberLiabilityData,
  GlacierPolicyApiUpdateCyberLiabilityResponse,
  GlacierPolicyApiUpdateDentistInformationData,
  GlacierPolicyApiUpdateDentistInformationResponse,
  GlacierPolicyApiUpdateDentistPricingData,
  GlacierPolicyApiUpdateDentistPricingResponse,
  GlacierPolicyApiUpdateDentistProceduresData,
  GlacierPolicyApiUpdateDentistProceduresResponse,
  GlacierPolicyApiUpdateDentistUnderwritingQuestionsData,
  GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponse,
  GlacierPolicyApiUpdateDocumentData,
  GlacierPolicyApiUpdatedOwnedEntityData,
  GlacierPolicyApiUpdatedOwnedEntityResponse,
  GlacierPolicyApiUpdateEmploymentPracticesLiabilityData,
  GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponse,
  GlacierPolicyApiUpdateErisaAndEmployeeBenefitsData,
  GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponse,
  GlacierPolicyApiUpdateGeneralLiabilityData,
  GlacierPolicyApiUpdateGeneralLiabilityResponse,
  GlacierPolicyApiUpdateLocationData,
  GlacierPolicyApiUpdateLocationResponse,
  GlacierPolicyApiUpdatePlCoverageData,
  GlacierPolicyApiUpdatePlCoverageResponse,
  GlacierPolicyApiUpdatePlPracticeOwnerData,
  GlacierPolicyApiUpdatePlPracticeOwnerResponse,
  GlacierPolicyApiUpdatePolicyDetailsData,
  GlacierPolicyApiUpdatePolicyDetailsResponse,
  GlacierPolicyApiUpdatePrimaryLocationData,
  GlacierPolicyApiUpdatePrimaryLocationResponse,
  GlacierPolicyApiUpdateUnderwriterNotesData,
  GlacierPolicyApiUpdateUnderwriterNotesResponse,
  GlacierPolicyApiUploadDocumentData,
  GlacierPolicyApiUploadDocumentsWithMetadataData,
  GlacierPolicyCloneApiCopyPolicyEndpointData,
  GlacierPolicyCloneApiCopyPolicyEndpointResponse,
  GlacierPolicyConditionsApiCreateBindingConditionData,
  GlacierPolicyConditionsApiCreateBindingConditionResponse,
  GlacierPolicyConditionsApiCreateTermsConditionData,
  GlacierPolicyConditionsApiCreateTermsConditionResponse,
  GlacierPolicyConditionsApiDeleteBindingConditionData,
  GlacierPolicyConditionsApiDeleteBindingConditionResponse,
  GlacierPolicyConditionsApiDeleteTermsConditionData,
  GlacierPolicyConditionsApiDeleteTermsConditionResponse,
  GlacierPolicyConditionsApiListBindingConditionsData,
  GlacierPolicyConditionsApiListBindingConditionsResponse,
  GlacierPolicyConditionsApiListTermsConditionsData,
  GlacierPolicyConditionsApiListTermsConditionsResponse,
  GlacierPolicyConditionsApiUpdateBindingConditionData,
  GlacierPolicyConditionsApiUpdateBindingConditionResponse,
  GlacierPolicyConditionsApiUpdateTermsConditionData,
  GlacierPolicyConditionsApiUpdateTermsConditionResponse,
  GlacierPolicyErpApiGetErpEligibleDatesData,
  GlacierPolicyErpApiGetErpEligibleDatesResponse,
  GlacierPolicyErpApiGetErpSectionsData,
  GlacierPolicyErpApiGetErpSectionsResponse,
  GlacierPolicyErpApiSaveErpSelectionsData,
  GlacierPolicyErpApiSaveErpSelectionsResponse,
  GlacierPolicyErpApiStartErpEndorsementData,
  GlacierPolicyErpApiStartErpEndorsementResponse,
  GlacierPolicyFormsApiAttachFormToDentistData,
  GlacierPolicyFormsApiAttachFormToDentistResponse,
  GlacierPolicyFormsApiAttachFormToEntityData,
  GlacierPolicyFormsApiAttachFormToEntityResponse,
  GlacierPolicyFormsApiAttachFormToLocationData,
  GlacierPolicyFormsApiAttachFormToLocationResponse,
  GlacierPolicyFormsApiAttachFormToPolicyData,
  GlacierPolicyFormsApiAttachFormToPolicyResponse,
  GlacierPolicyFormsApiDetachFormFromDentistData,
  GlacierPolicyFormsApiDetachFormFromEntityData,
  GlacierPolicyFormsApiDetachFormFromLocationData,
  GlacierPolicyFormsApiDetachFormFromPolicyData,
  GlacierPolicyFormsApiGetAvailableEndorsementsData,
  GlacierPolicyFormsApiGetAvailableEndorsementsResponse,
  GlacierPolicyFormsApiGetDentistAttachedFormsData,
  GlacierPolicyFormsApiGetDentistAttachedFormsResponse,
  GlacierPolicyFormsApiGetDentistAvailableEndorsementsData,
  GlacierPolicyFormsApiGetDentistAvailableEndorsementsResponse,
  GlacierPolicyFormsApiGetEntityAttachedFormsData,
  GlacierPolicyFormsApiGetEntityAttachedFormsResponse,
  GlacierPolicyFormsApiGetEntityAvailableEndorsementsData,
  GlacierPolicyFormsApiGetEntityAvailableEndorsementsResponse,
  GlacierPolicyFormsApiGetLocationAttachedFormsData,
  GlacierPolicyFormsApiGetLocationAttachedFormsResponse,
  GlacierPolicyFormsApiGetLocationAvailableEndorsementsData,
  GlacierPolicyFormsApiGetLocationAvailableEndorsementsResponse,
  GlacierPolicyFormsApiGetQuestionsByDentistData,
  GlacierPolicyFormsApiGetQuestionsByDentistResponse,
  GlacierPolicyFormsApiGetQuestionsByEntityData,
  GlacierPolicyFormsApiGetQuestionsByEntityResponse,
  GlacierPolicyFormsApiGetQuestionsByLocationData,
  GlacierPolicyFormsApiGetQuestionsByLocationResponse,
  GlacierPolicyFormsApiGetQuestionsByPolicyData,
  GlacierPolicyFormsApiGetQuestionsByPolicyResponse,
  GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsData,
  GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsResponse,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData,
  GlacierPolicyFormsApiRenderFormData,
  GlacierPolicyFormsApiRenderFormResponse,
  GlacierUsersApiCurrentUserData,
  GlacierUsersApiCurrentUserResponse,
  GlacierUsersApiForgotPasswordEndpointData,
  GlacierUsersApiForgotPasswordEndpointResponse,
  GlacierUsersApiListUsersData,
  GlacierUsersApiListUsersResponse,
  GlacierUsersApiRelatedUsersData,
  GlacierUsersApiRelatedUsersResponse,
  GlacierUsersApiResetPasswordEndpointData,
  GlacierUsersApiResetPasswordEndpointResponse,
  GlacierUsersApiUnderwritersData,
  GlacierUsersApiUnderwritersResponse,
  GlacierUsersFeatureFlagsApiGetFeatureFlagsData,
  GlacierUsersFeatureFlagsApiGetFeatureFlagsResponse,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl:
      options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const glacierUsersApiListUsersQueryKey = (
  options?: Options<GlacierUsersApiListUsersData>
) => createQueryKey('glacierUsersApiListUsers', options);

/**
 * List Users
 */
export const glacierUsersApiListUsersOptions = (
  options?: Options<GlacierUsersApiListUsersData>
) =>
  queryOptions<
    GlacierUsersApiListUsersResponse,
    DefaultError,
    GlacierUsersApiListUsersResponse,
    ReturnType<typeof glacierUsersApiListUsersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierUsersApiListUsers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierUsersApiListUsersQueryKey(options),
  });

export const glacierUsersApiCurrentUserQueryKey = (
  options?: Options<GlacierUsersApiCurrentUserData>
) => createQueryKey('glacierUsersApiCurrentUser', options);

/**
 * Current User
 */
export const glacierUsersApiCurrentUserOptions = (
  options?: Options<GlacierUsersApiCurrentUserData>
) =>
  queryOptions<
    GlacierUsersApiCurrentUserResponse,
    DefaultError,
    GlacierUsersApiCurrentUserResponse,
    ReturnType<typeof glacierUsersApiCurrentUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierUsersApiCurrentUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierUsersApiCurrentUserQueryKey(options),
  });

export const glacierUsersApiRelatedUsersQueryKey = (
  options?: Options<GlacierUsersApiRelatedUsersData>
) => createQueryKey('glacierUsersApiRelatedUsers', options);

/**
 * Related Users
 */
export const glacierUsersApiRelatedUsersOptions = (
  options?: Options<GlacierUsersApiRelatedUsersData>
) =>
  queryOptions<
    GlacierUsersApiRelatedUsersResponse,
    DefaultError,
    GlacierUsersApiRelatedUsersResponse,
    ReturnType<typeof glacierUsersApiRelatedUsersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierUsersApiRelatedUsers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierUsersApiRelatedUsersQueryKey(options),
  });

export const glacierUsersApiUnderwritersQueryKey = (
  options?: Options<GlacierUsersApiUnderwritersData>
) => createQueryKey('glacierUsersApiUnderwriters', options);

/**
 * Underwriters
 */
export const glacierUsersApiUnderwritersOptions = (
  options?: Options<GlacierUsersApiUnderwritersData>
) =>
  queryOptions<
    GlacierUsersApiUnderwritersResponse,
    DefaultError,
    GlacierUsersApiUnderwritersResponse,
    ReturnType<typeof glacierUsersApiUnderwritersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierUsersApiUnderwriters({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierUsersApiUnderwritersQueryKey(options),
  });

/**
 * Forgot Password Endpoint
 */
export const glacierUsersApiForgotPasswordEndpointMutation = (
  options?: Partial<Options<GlacierUsersApiForgotPasswordEndpointData>>
): UseMutationOptions<
  GlacierUsersApiForgotPasswordEndpointResponse,
  DefaultError,
  Options<GlacierUsersApiForgotPasswordEndpointData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierUsersApiForgotPasswordEndpointResponse,
    DefaultError,
    Options<GlacierUsersApiForgotPasswordEndpointData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierUsersApiForgotPasswordEndpoint({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Reset Password Endpoint
 */
export const glacierUsersApiResetPasswordEndpointMutation = (
  options?: Partial<Options<GlacierUsersApiResetPasswordEndpointData>>
): UseMutationOptions<
  GlacierUsersApiResetPasswordEndpointResponse,
  DefaultError,
  Options<GlacierUsersApiResetPasswordEndpointData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierUsersApiResetPasswordEndpointResponse,
    DefaultError,
    Options<GlacierUsersApiResetPasswordEndpointData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierUsersApiResetPasswordEndpoint({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierUsersFeatureFlagsApiGetFeatureFlagsQueryKey = (
  options?: Options<GlacierUsersFeatureFlagsApiGetFeatureFlagsData>
) => createQueryKey('glacierUsersFeatureFlagsApiGetFeatureFlags', options);

/**
 * Get Feature Flags
 *
 * Return all switches marked `deliverable_to_ui` with their current active state.
 *
 * Unauthenticated callers receive the same response as authenticated ones —
 * the deliverable_to_ui flag controls visibility, not auth state.
 */
export const glacierUsersFeatureFlagsApiGetFeatureFlagsOptions = (
  options?: Options<GlacierUsersFeatureFlagsApiGetFeatureFlagsData>
) =>
  queryOptions<
    GlacierUsersFeatureFlagsApiGetFeatureFlagsResponse,
    DefaultError,
    GlacierUsersFeatureFlagsApiGetFeatureFlagsResponse,
    ReturnType<typeof glacierUsersFeatureFlagsApiGetFeatureFlagsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierUsersFeatureFlagsApiGetFeatureFlags({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierUsersFeatureFlagsApiGetFeatureFlagsQueryKey(options),
  });

export const glacierPolicyApiListPoliciesQueryKey = (
  options?: Options<GlacierPolicyApiListPoliciesData>
) => createQueryKey('glacierPolicyApiListPolicies', options);

/**
 * List Policies
 *
 * List policies the requesting user may access.
 *
 * Staff are unrestricted (including DISCARDED), exactly as before this gate. Non-staff
 * are scoped to the policies their agency may access via
 * ``PolicyLookupTable.user_permission_qs`` -- the same tenancy primitive
 * ``get_policy_summary`` uses -- so an agent only ever sees their own agencies' policies
 * rather than the entire event store (DC-3454).
 */
export const glacierPolicyApiListPoliciesOptions = (
  options?: Options<GlacierPolicyApiListPoliciesData>
) =>
  queryOptions<
    GlacierPolicyApiListPoliciesResponse,
    DefaultError,
    GlacierPolicyApiListPoliciesResponse,
    ReturnType<typeof glacierPolicyApiListPoliciesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiListPolicies({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiListPoliciesQueryKey(options),
  });

/**
 * Create Policy
 */
export const glacierPolicyApiCreatePolicyMutation = (
  options?: Partial<Options<GlacierPolicyApiCreatePolicyData>>
): UseMutationOptions<
  GlacierPolicyApiCreatePolicyResponse,
  DefaultError,
  Options<GlacierPolicyApiCreatePolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiCreatePolicyResponse,
    DefaultError,
    Options<GlacierPolicyApiCreatePolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiCreatePolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetPolicySummaryQueryKey = (
  options?: Options<GlacierPolicyApiGetPolicySummaryData>
) => createQueryKey('glacierPolicyApiGetPolicySummary', options);

/**
 * Get Policy Summary
 */
export const glacierPolicyApiGetPolicySummaryOptions = (
  options?: Options<GlacierPolicyApiGetPolicySummaryData>
) =>
  queryOptions<
    GlacierPolicyApiGetPolicySummaryResponse,
    DefaultError,
    GlacierPolicyApiGetPolicySummaryResponse,
    ReturnType<typeof glacierPolicyApiGetPolicySummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPolicySummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPolicySummaryQueryKey(options),
  });

export const glacierPolicyApiGetPolicySummarySearchQueryKey = (
  options: Options<GlacierPolicyApiGetPolicySummarySearchData>
) => createQueryKey('glacierPolicyApiGetPolicySummarySearch', options);

/**
 * Get Policy Summary Search
 *
 * Evergreen Dashboard "Insureds only" search.
 *
 * Restricted to First Named Insured and insured dentist names, tokenized
 * and order-independent, spanning every transaction status the user can
 * otherwise see -- see ``PolicyLookupTable.insured_search``.
 */
export const glacierPolicyApiGetPolicySummarySearchOptions = (
  options: Options<GlacierPolicyApiGetPolicySummarySearchData>
) =>
  queryOptions<
    GlacierPolicyApiGetPolicySummarySearchResponse,
    DefaultError,
    GlacierPolicyApiGetPolicySummarySearchResponse,
    ReturnType<typeof glacierPolicyApiGetPolicySummarySearchQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPolicySummarySearch({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPolicySummarySearchQueryKey(options),
  });

/**
 * Delete Print Queue
 *
 * Deletes a print queue item specified by `print_queue_id`.
 *
 * This function performs a soft delete operation on the print queue
 * by setting its 'deleted_at' attribute to the current timestamp.
 */
export const glacierPolicyApiDeletePrintQueueMutation = (
  options?: Partial<Options<GlacierPolicyApiDeletePrintQueueData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiDeletePrintQueueData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiDeletePrintQueueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDeletePrintQueue({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetPrintQueueQueryKey = (
  options?: Options<GlacierPolicyApiGetPrintQueueData>
) => createQueryKey('glacierPolicyApiGetPrintQueue', options);

/**
 * Get Print Queue
 *
 * Returns the list of policies that are visible to the print queue
 */
export const glacierPolicyApiGetPrintQueueOptions = (
  options?: Options<GlacierPolicyApiGetPrintQueueData>
) =>
  queryOptions<
    GlacierPolicyApiGetPrintQueueResponse,
    DefaultError,
    GlacierPolicyApiGetPrintQueueResponse,
    ReturnType<typeof glacierPolicyApiGetPrintQueueQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPrintQueue({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPrintQueueQueryKey(options),
  });

/**
 * Print Queue
 *
 * Starts a print queue for the given accounts, and return the zip file
 */
export const glacierPolicyApiPrintQueueMutation = (
  options?: Partial<Options<GlacierPolicyApiPrintQueueData>>
): UseMutationOptions<
  GlacierPolicyApiPrintQueueResponse,
  DefaultError,
  Options<GlacierPolicyApiPrintQueueData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiPrintQueueResponse,
    DefaultError,
    Options<GlacierPolicyApiPrintQueueData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiPrintQueue({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetPolicyQueryKey = (
  options: Options<GlacierPolicyApiGetPolicyData>
) => createQueryKey('glacierPolicyApiGetPolicy', options);

/**
 * Get Policy
 */
export const glacierPolicyApiGetPolicyOptions = (
  options: Options<GlacierPolicyApiGetPolicyData>
) =>
  queryOptions<
    GlacierPolicyApiGetPolicyResponse,
    DefaultError,
    GlacierPolicyApiGetPolicyResponse,
    ReturnType<typeof glacierPolicyApiGetPolicyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPolicy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPolicyQueryKey(options),
  });

export const glacierPolicyApiGetPolicyAlertsQueryKey = (
  options: Options<GlacierPolicyApiGetPolicyAlertsData>
) => createQueryKey('glacierPolicyApiGetPolicyAlerts', options);

/**
 * Get Policy Alerts
 */
export const glacierPolicyApiGetPolicyAlertsOptions = (
  options: Options<GlacierPolicyApiGetPolicyAlertsData>
) =>
  queryOptions<
    GlacierPolicyApiGetPolicyAlertsResponse,
    DefaultError,
    GlacierPolicyApiGetPolicyAlertsResponse,
    ReturnType<typeof glacierPolicyApiGetPolicyAlertsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPolicyAlerts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPolicyAlertsQueryKey(options),
  });

/**
 * Acknowledge Policy Alert
 */
export const glacierPolicyApiAcknowledgePolicyAlertMutation = (
  options?: Partial<Options<GlacierPolicyApiAcknowledgePolicyAlertData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiAcknowledgePolicyAlertData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiAcknowledgePolicyAlertData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiAcknowledgePolicyAlert({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetLatestTransactionSummaryQueryKey = (
  options: Options<GlacierPolicyApiGetLatestTransactionSummaryData>
) => createQueryKey('glacierPolicyApiGetLatestTransactionSummary', options);

/**
 * Get Latest Transaction Summary
 */
export const glacierPolicyApiGetLatestTransactionSummaryOptions = (
  options: Options<GlacierPolicyApiGetLatestTransactionSummaryData>
) =>
  queryOptions<
    GlacierPolicyApiGetLatestTransactionSummaryResponse,
    DefaultError,
    GlacierPolicyApiGetLatestTransactionSummaryResponse,
    ReturnType<typeof glacierPolicyApiGetLatestTransactionSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetLatestTransactionSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetLatestTransactionSummaryQueryKey(options),
  });

export const glacierPolicyApiGetLatestTransactionLatestAttemptQueryKey = (
  options: Options<GlacierPolicyApiGetLatestTransactionLatestAttemptData>
) =>
  createQueryKey('glacierPolicyApiGetLatestTransactionLatestAttempt', options);

/**
 * Get Latest Transaction Latest Attempt
 */
export const glacierPolicyApiGetLatestTransactionLatestAttemptOptions = (
  options: Options<GlacierPolicyApiGetLatestTransactionLatestAttemptData>
) =>
  queryOptions<
    GlacierPolicyApiGetLatestTransactionLatestAttemptResponse,
    DefaultError,
    GlacierPolicyApiGetLatestTransactionLatestAttemptResponse,
    ReturnType<typeof glacierPolicyApiGetLatestTransactionLatestAttemptQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetLatestTransactionLatestAttempt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      glacierPolicyApiGetLatestTransactionLatestAttemptQueryKey(options),
  });

/**
 * Assign Agent
 */
export const glacierPolicyApiAssignAgentMutation = (
  options?: Partial<Options<GlacierPolicyApiAssignAgentData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiAssignAgentData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiAssignAgentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiAssignAgent({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Assign Underwriter
 */
export const glacierPolicyApiAssignUnderwriterMutation = (
  options?: Partial<Options<GlacierPolicyApiAssignUnderwriterData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiAssignUnderwriterData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiAssignUnderwriterData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiAssignUnderwriter({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Assign
 */
export const glacierPolicyApiAssignMutation = (
  options?: Partial<Options<GlacierPolicyApiAssignData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiAssignData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiAssignData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiAssign({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiAssignableQueryKey = (
  options: Options<GlacierPolicyApiAssignableData>
) => createQueryKey('glacierPolicyApiAssignable', options);

/**
 * Assignable
 */
export const glacierPolicyApiAssignableOptions = (
  options: Options<GlacierPolicyApiAssignableData>
) =>
  queryOptions<
    GlacierPolicyApiAssignableResponse,
    DefaultError,
    GlacierPolicyApiAssignableResponse,
    ReturnType<typeof glacierPolicyApiAssignableQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiAssignable({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiAssignableQueryKey(options),
  });

export const glacierPolicyApiGetPolicyWithSummariesQueryKey = (
  options: Options<GlacierPolicyApiGetPolicyWithSummariesData>
) => createQueryKey('glacierPolicyApiGetPolicyWithSummaries', options);

/**
 * Get Policy With Summaries
 */
export const glacierPolicyApiGetPolicyWithSummariesOptions = (
  options: Options<GlacierPolicyApiGetPolicyWithSummariesData>
) =>
  queryOptions<
    GlacierPolicyApiGetPolicyWithSummariesResponse,
    DefaultError,
    GlacierPolicyApiGetPolicyWithSummariesResponse,
    ReturnType<typeof glacierPolicyApiGetPolicyWithSummariesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPolicyWithSummaries({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPolicyWithSummariesQueryKey(options),
  });

export const glacierPolicyApiGetPolicyPermissionsQueryKey = (
  options: Options<GlacierPolicyApiGetPolicyPermissionsData>
) => createQueryKey('glacierPolicyApiGetPolicyPermissions', options);

/**
 * Get Policy Permissions
 */
export const glacierPolicyApiGetPolicyPermissionsOptions = (
  options: Options<GlacierPolicyApiGetPolicyPermissionsData>
) =>
  queryOptions<
    GlacierPolicyApiGetPolicyPermissionsResponse,
    DefaultError,
    GlacierPolicyApiGetPolicyPermissionsResponse,
    ReturnType<typeof glacierPolicyApiGetPolicyPermissionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPolicyPermissions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPolicyPermissionsQueryKey(options),
  });

/**
 * Decline Transaction
 *
 * This acts as DECLINE or NOT TAKEN if user is an Underwriter or Agent respectively
 */
export const glacierPolicyApiDeclineTransactionMutation = (
  options?: Partial<Options<GlacierPolicyApiDeclineTransactionData>>
): UseMutationOptions<
  GlacierPolicyApiDeclineTransactionResponse,
  GlacierPolicyApiDeclineTransactionError,
  Options<GlacierPolicyApiDeclineTransactionData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDeclineTransactionResponse,
    GlacierPolicyApiDeclineTransactionError,
    Options<GlacierPolicyApiDeclineTransactionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDeclineTransaction({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Discard Transaction
 *
 * Discards a transaction. A discarded transaction cannot be reopened
 */
export const glacierPolicyApiDiscardTransactionMutation = (
  options?: Partial<Options<GlacierPolicyApiDiscardTransactionData>>
): UseMutationOptions<
  GlacierPolicyApiDiscardTransactionResponse,
  GlacierPolicyApiDiscardTransactionError,
  Options<GlacierPolicyApiDiscardTransactionData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDiscardTransactionResponse,
    GlacierPolicyApiDiscardTransactionError,
    Options<GlacierPolicyApiDiscardTransactionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDiscardTransaction({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Reopen Transaction
 *
 * Reopens a transaction. Only transactions that are in DECLINED or NOT_TAKEN can be reopened
 */
export const glacierPolicyApiReopenTransactionMutation = (
  options?: Partial<Options<GlacierPolicyApiReopenTransactionData>>
): UseMutationOptions<
  GlacierPolicyApiReopenTransactionResponse,
  GlacierPolicyApiReopenTransactionError,
  Options<GlacierPolicyApiReopenTransactionData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiReopenTransactionResponse,
    GlacierPolicyApiReopenTransactionError,
    Options<GlacierPolicyApiReopenTransactionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiReopenTransaction({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add Location
 */
export const glacierPolicyApiAddLocationMutation = (
  options?: Partial<Options<GlacierPolicyApiAddLocationData>>
): UseMutationOptions<
  GlacierPolicyApiAddLocationResponse,
  DefaultError,
  Options<GlacierPolicyApiAddLocationData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiAddLocationResponse,
    DefaultError,
    Options<GlacierPolicyApiAddLocationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiAddLocation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Primary Location
 */
export const glacierPolicyApiUpdatePrimaryLocationMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdatePrimaryLocationData>>
): UseMutationOptions<
  GlacierPolicyApiUpdatePrimaryLocationResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdatePrimaryLocationData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdatePrimaryLocationResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdatePrimaryLocationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdatePrimaryLocation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Location
 */
export const glacierPolicyApiDeleteLocationMutation = (
  options?: Partial<Options<GlacierPolicyApiDeleteLocationData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiDeleteLocationData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiDeleteLocationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDeleteLocation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetLocationQueryKey = (
  options: Options<GlacierPolicyApiGetLocationData>
) => createQueryKey('glacierPolicyApiGetLocation', options);

/**
 * Get Location
 */
export const glacierPolicyApiGetLocationOptions = (
  options: Options<GlacierPolicyApiGetLocationData>
) =>
  queryOptions<
    GlacierPolicyApiGetLocationResponse,
    DefaultError,
    GlacierPolicyApiGetLocationResponse,
    ReturnType<typeof glacierPolicyApiGetLocationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetLocation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetLocationQueryKey(options),
  });

/**
 * Update Location
 */
export const glacierPolicyApiUpdateLocationMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateLocationData>>
): UseMutationOptions<
  GlacierPolicyApiUpdateLocationResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateLocationData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateLocationResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateLocationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateLocation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Update Locations
 */
export const glacierPolicyApiBulkUpdateLocationsMutation = (
  options?: Partial<Options<GlacierPolicyApiBulkUpdateLocationsData>>
): UseMutationOptions<
  GlacierPolicyApiBulkUpdateLocationsResponse,
  DefaultError,
  Options<GlacierPolicyApiBulkUpdateLocationsData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiBulkUpdateLocationsResponse,
    DefaultError,
    Options<GlacierPolicyApiBulkUpdateLocationsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiBulkUpdateLocations({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Undo Delete Location
 */
export const glacierPolicyApiUndoDeleteLocationMutation = (
  options?: Partial<Options<GlacierPolicyApiUndoDeleteLocationData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiUndoDeleteLocationData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiUndoDeleteLocationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUndoDeleteLocation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetDentistQueryKey = (
  options: Options<GlacierPolicyApiGetDentistData>
) => createQueryKey('glacierPolicyApiGetDentist', options);

/**
 * Get Dentist
 */
export const glacierPolicyApiGetDentistOptions = (
  options: Options<GlacierPolicyApiGetDentistData>
) =>
  queryOptions<
    GlacierPolicyApiGetDentistResponse,
    DefaultError,
    GlacierPolicyApiGetDentistResponse,
    ReturnType<typeof glacierPolicyApiGetDentistQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetDentist({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetDentistQueryKey(options),
  });

/**
 * Set Dentist As First Named Insured
 *
 * Set a dentist as the first named insured for the policy.
 * Expects a dentist ID in the request body.
 */
export const glacierPolicyApiSetDentistAsFirstNamedInsuredMutation = (
  options?: Partial<Options<GlacierPolicyApiSetDentistAsFirstNamedInsuredData>>
): UseMutationOptions<
  GlacierPolicyApiSetDentistAsFirstNamedInsuredResponse,
  DefaultError,
  Options<GlacierPolicyApiSetDentistAsFirstNamedInsuredData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiSetDentistAsFirstNamedInsuredResponse,
    DefaultError,
    Options<GlacierPolicyApiSetDentistAsFirstNamedInsuredData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiSetDentistAsFirstNamedInsured({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set Owned Entity As First Named Insured
 *
 * Set an owned entity as the first named insured for the policy.
 * Expects an owned entity ID in the request body.
 */
export const glacierPolicyApiSetOwnedEntityAsFirstNamedInsuredMutation = (
  options?: Partial<
    Options<GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredData>
  >
): UseMutationOptions<
  GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredResponse,
  DefaultError,
  Options<GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredResponse,
    DefaultError,
    Options<GlacierPolicyApiSetOwnedEntityAsFirstNamedInsuredData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiSetOwnedEntityAsFirstNamedInsured({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add Dentist
 */
export const glacierPolicyApiAddDentistMutation = (
  options?: Partial<Options<GlacierPolicyApiAddDentistData>>
): UseMutationOptions<
  GlacierPolicyApiAddDentistResponse,
  DefaultError,
  Options<GlacierPolicyApiAddDentistData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiAddDentistResponse,
    DefaultError,
    Options<GlacierPolicyApiAddDentistData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiAddDentist({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Dentist
 */
export const glacierPolicyApiDeleteDentistMutation = (
  options?: Partial<Options<GlacierPolicyApiDeleteDentistData>>
): UseMutationOptions<
  GlacierPolicyApiDeleteDentistResponse,
  DefaultError,
  Options<GlacierPolicyApiDeleteDentistData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDeleteDentistResponse,
    DefaultError,
    Options<GlacierPolicyApiDeleteDentistData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDeleteDentist({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Basic Dentist
 */
export const glacierPolicyApiUpdateBasicDentistMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateBasicDentistData>>
): UseMutationOptions<
  GlacierPolicyApiUpdateBasicDentistResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateBasicDentistData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateBasicDentistResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateBasicDentistData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateBasicDentist({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Undo Delete Dentist
 */
export const glacierPolicyApiUndoDeleteDentistMutation = (
  options?: Partial<Options<GlacierPolicyApiUndoDeleteDentistData>>
): UseMutationOptions<
  GlacierPolicyApiUndoDeleteDentistResponse,
  DefaultError,
  Options<GlacierPolicyApiUndoDeleteDentistData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUndoDeleteDentistResponse,
    DefaultError,
    Options<GlacierPolicyApiUndoDeleteDentistData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUndoDeleteDentist({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetDentistInformationQueryKey = (
  options: Options<GlacierPolicyApiGetDentistInformationData>
) => createQueryKey('glacierPolicyApiGetDentistInformation', options);

/**
 * Get Dentist Information
 */
export const glacierPolicyApiGetDentistInformationOptions = (
  options: Options<GlacierPolicyApiGetDentistInformationData>
) =>
  queryOptions<
    GlacierPolicyApiGetDentistInformationResponse,
    DefaultError,
    GlacierPolicyApiGetDentistInformationResponse,
    ReturnType<typeof glacierPolicyApiGetDentistInformationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetDentistInformation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetDentistInformationQueryKey(options),
  });

/**
 * Update Dentist Information
 */
export const glacierPolicyApiUpdateDentistInformationMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateDentistInformationData>>
): UseMutationOptions<
  GlacierPolicyApiUpdateDentistInformationResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateDentistInformationData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateDentistInformationResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateDentistInformationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateDentistInformation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetDentistPricingQueryKey = (
  options: Options<GlacierPolicyApiGetDentistPricingData>
) => createQueryKey('glacierPolicyApiGetDentistPricing', options);

/**
 * Get Dentist Pricing
 */
export const glacierPolicyApiGetDentistPricingOptions = (
  options: Options<GlacierPolicyApiGetDentistPricingData>
) =>
  queryOptions<
    GlacierPolicyApiGetDentistPricingResponse,
    DefaultError,
    GlacierPolicyApiGetDentistPricingResponse,
    ReturnType<typeof glacierPolicyApiGetDentistPricingQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetDentistPricing({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetDentistPricingQueryKey(options),
  });

/**
 * Update Dentist Pricing
 */
export const glacierPolicyApiUpdateDentistPricingMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateDentistPricingData>>
): UseMutationOptions<
  GlacierPolicyApiUpdateDentistPricingResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateDentistPricingData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateDentistPricingResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateDentistPricingData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateDentistPricing({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetDentistProceduresQueryKey = (
  options: Options<GlacierPolicyApiGetDentistProceduresData>
) => createQueryKey('glacierPolicyApiGetDentistProcedures', options);

/**
 * Get Dentist Procedures
 */
export const glacierPolicyApiGetDentistProceduresOptions = (
  options: Options<GlacierPolicyApiGetDentistProceduresData>
) =>
  queryOptions<
    GlacierPolicyApiGetDentistProceduresResponse,
    DefaultError,
    GlacierPolicyApiGetDentistProceduresResponse,
    ReturnType<typeof glacierPolicyApiGetDentistProceduresQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetDentistProcedures({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetDentistProceduresQueryKey(options),
  });

/**
 * Update Dentist Procedures
 */
export const glacierPolicyApiUpdateDentistProceduresMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateDentistProceduresData>>
): UseMutationOptions<
  GlacierPolicyApiUpdateDentistProceduresResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateDentistProceduresData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateDentistProceduresResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateDentistProceduresData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateDentistProcedures({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Search Truthmd Data
 *
 * Search TruthMD platform for dentist data.
 * Requires either NPI or licenseNumber + licenseState combination.
 */
export const glacierPolicyApiSearchTruthmdDataMutation = (
  options?: Partial<Options<GlacierPolicyApiSearchTruthmdDataData>>
): UseMutationOptions<
  GlacierPolicyApiSearchTruthmdDataResponse,
  DefaultError,
  Options<GlacierPolicyApiSearchTruthmdDataData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiSearchTruthmdDataResponse,
    DefaultError,
    Options<GlacierPolicyApiSearchTruthmdDataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiSearchTruthmdData({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Clear Dentist Truthmd
 *
 * Clear TruthMD data for a dentist.
 * This removes all TruthMD data associated with the dentist.
 */
export const glacierPolicyApiClearDentistTruthmdMutation = (
  options?: Partial<Options<GlacierPolicyApiClearDentistTruthmdData>>
): UseMutationOptions<
  GlacierPolicyApiClearDentistTruthmdResponse,
  DefaultError,
  Options<GlacierPolicyApiClearDentistTruthmdData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiClearDentistTruthmdResponse,
    DefaultError,
    Options<GlacierPolicyApiClearDentistTruthmdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiClearDentistTruthmd({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Save Dentist Truthmd
 *
 * Save TruthMD data for a dentist.
 * Call this endpoint after searching to persist the TruthMD data.
 */
export const glacierPolicyApiSaveDentistTruthmdMutation = (
  options?: Partial<Options<GlacierPolicyApiSaveDentistTruthmdData>>
): UseMutationOptions<
  GlacierPolicyApiSaveDentistTruthmdResponse,
  DefaultError,
  Options<GlacierPolicyApiSaveDentistTruthmdData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiSaveDentistTruthmdResponse,
    DefaultError,
    Options<GlacierPolicyApiSaveDentistTruthmdData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiSaveDentistTruthmd({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetPracticeOwnersQueryKey = (
  options: Options<GlacierPolicyApiGetPracticeOwnersData>
) => createQueryKey('glacierPolicyApiGetPracticeOwners', options);

/**
 * Get Practice Owners
 */
export const glacierPolicyApiGetPracticeOwnersOptions = (
  options: Options<GlacierPolicyApiGetPracticeOwnersData>
) =>
  queryOptions<
    GlacierPolicyApiGetPracticeOwnersResponse,
    DefaultError,
    GlacierPolicyApiGetPracticeOwnersResponse,
    ReturnType<typeof glacierPolicyApiGetPracticeOwnersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPracticeOwners({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPracticeOwnersQueryKey(options),
  });

/**
 * Update Pl Practice Owner
 */
export const glacierPolicyApiUpdatePlPracticeOwnerMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdatePlPracticeOwnerData>>
): UseMutationOptions<
  GlacierPolicyApiUpdatePlPracticeOwnerResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdatePlPracticeOwnerData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdatePlPracticeOwnerResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdatePlPracticeOwnerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdatePlPracticeOwner({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetPlCoverageQueryKey = (
  options: Options<GlacierPolicyApiGetPlCoverageData>
) => createQueryKey('glacierPolicyApiGetPlCoverage', options);

/**
 * Get Pl Coverage
 */
export const glacierPolicyApiGetPlCoverageOptions = (
  options: Options<GlacierPolicyApiGetPlCoverageData>
) =>
  queryOptions<
    GlacierPolicyApiGetPlCoverageResponse,
    DefaultError,
    GlacierPolicyApiGetPlCoverageResponse,
    ReturnType<typeof glacierPolicyApiGetPlCoverageQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPlCoverage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPlCoverageQueryKey(options),
  });

/**
 * Update Pl Coverage
 */
export const glacierPolicyApiUpdatePlCoverageMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdatePlCoverageData>>
): UseMutationOptions<
  GlacierPolicyApiUpdatePlCoverageResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdatePlCoverageData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdatePlCoverageResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdatePlCoverageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdatePlCoverage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetPolicyDetailsQueryKey = (
  options: Options<GlacierPolicyApiGetPolicyDetailsData>
) => createQueryKey('glacierPolicyApiGetPolicyDetails', options);

/**
 * Get Policy Details
 */
export const glacierPolicyApiGetPolicyDetailsOptions = (
  options: Options<GlacierPolicyApiGetPolicyDetailsData>
) =>
  queryOptions<
    GlacierPolicyApiGetPolicyDetailsResponse,
    DefaultError,
    GlacierPolicyApiGetPolicyDetailsResponse,
    ReturnType<typeof glacierPolicyApiGetPolicyDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPolicyDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPolicyDetailsQueryKey(options),
  });

/**
 * Update Policy Details
 */
export const glacierPolicyApiUpdatePolicyDetailsMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdatePolicyDetailsData>>
): UseMutationOptions<
  GlacierPolicyApiUpdatePolicyDetailsResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdatePolicyDetailsData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdatePolicyDetailsResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdatePolicyDetailsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdatePolicyDetails({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Bypass Validators
 */
export const glacierPolicyApiUpdateBypassValidatorsMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateBypassValidatorsData>>
): UseMutationOptions<
  GlacierPolicyApiUpdateBypassValidatorsResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateBypassValidatorsData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateBypassValidatorsResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateBypassValidatorsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateBypassValidators({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Refresh Commercial Property With Verisk
 */
export const glacierPolicyApiRefreshCommercialPropertyWithVeriskMutation = (
  options?: Partial<
    Options<GlacierPolicyApiRefreshCommercialPropertyWithVeriskData>
  >
): UseMutationOptions<
  GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponse,
  DefaultError,
  Options<GlacierPolicyApiRefreshCommercialPropertyWithVeriskData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponse,
    DefaultError,
    Options<GlacierPolicyApiRefreshCommercialPropertyWithVeriskData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await glacierPolicyApiRefreshCommercialPropertyWithVerisk({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Refresh Commercial Property With Corelogic
 */
export const glacierPolicyApiRefreshCommercialPropertyWithCorelogicMutation = (
  options?: Partial<
    Options<GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData>
  >
): UseMutationOptions<
  GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponse,
  DefaultError,
  Options<GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponse,
    DefaultError,
    Options<GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await glacierPolicyApiRefreshCommercialPropertyWithCorelogic({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add Commercial Property Coverage
 */
export const glacierPolicyApiAddCommercialPropertyCoverageMutation = (
  options?: Partial<Options<GlacierPolicyApiAddCommercialPropertyCoverageData>>
): UseMutationOptions<
  GlacierPolicyApiAddCommercialPropertyCoverageResponse,
  DefaultError,
  Options<GlacierPolicyApiAddCommercialPropertyCoverageData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiAddCommercialPropertyCoverageResponse,
    DefaultError,
    Options<GlacierPolicyApiAddCommercialPropertyCoverageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiAddCommercialPropertyCoverage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Commercial Property Coverage
 */
export const glacierPolicyApiDeleteCommercialPropertyCoverageMutation = (
  options?: Partial<
    Options<GlacierPolicyApiDeleteCommercialPropertyCoverageData>
  >
): UseMutationOptions<
  GlacierPolicyApiDeleteCommercialPropertyCoverageResponse,
  DefaultError,
  Options<GlacierPolicyApiDeleteCommercialPropertyCoverageData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDeleteCommercialPropertyCoverageResponse,
    DefaultError,
    Options<GlacierPolicyApiDeleteCommercialPropertyCoverageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDeleteCommercialPropertyCoverage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetCommercialPropertyLocationQueryKey = (
  options: Options<GlacierPolicyApiGetCommercialPropertyLocationData>
) => createQueryKey('glacierPolicyApiGetCommercialPropertyLocation', options);

/**
 * Get Commercial Property Location
 */
export const glacierPolicyApiGetCommercialPropertyLocationOptions = (
  options: Options<GlacierPolicyApiGetCommercialPropertyLocationData>
) =>
  queryOptions<
    GlacierPolicyApiGetCommercialPropertyLocationResponse,
    DefaultError,
    GlacierPolicyApiGetCommercialPropertyLocationResponse,
    ReturnType<typeof glacierPolicyApiGetCommercialPropertyLocationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetCommercialPropertyLocation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetCommercialPropertyLocationQueryKey(options),
  });

/**
 * Update Commercial Property Coverage
 */
export const glacierPolicyApiUpdateCommercialPropertyCoverageMutation = (
  options?: Partial<
    Options<GlacierPolicyApiUpdateCommercialPropertyCoverageData>
  >
): UseMutationOptions<
  GlacierPolicyApiUpdateCommercialPropertyCoverageResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateCommercialPropertyCoverageData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateCommercialPropertyCoverageResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateCommercialPropertyCoverageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateCommercialPropertyCoverage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Undo Delete Commercial Property Coverage
 */
export const glacierPolicyApiUndoDeleteCommercialPropertyCoverageMutation = (
  options?: Partial<
    Options<GlacierPolicyApiUndoDeleteCommercialPropertyCoverageData>
  >
): UseMutationOptions<
  GlacierPolicyApiUndoDeleteCommercialPropertyCoverageResponse,
  DefaultError,
  Options<GlacierPolicyApiUndoDeleteCommercialPropertyCoverageData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUndoDeleteCommercialPropertyCoverageResponse,
    DefaultError,
    Options<GlacierPolicyApiUndoDeleteCommercialPropertyCoverageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await glacierPolicyApiUndoDeleteCommercialPropertyCoverage({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetCommercialPropertyCoverageQueryKey = (
  options: Options<GlacierPolicyApiGetCommercialPropertyCoverageData>
) => createQueryKey('glacierPolicyApiGetCommercialPropertyCoverage', options);

/**
 * Get Commercial Property Coverage
 */
export const glacierPolicyApiGetCommercialPropertyCoverageOptions = (
  options: Options<GlacierPolicyApiGetCommercialPropertyCoverageData>
) =>
  queryOptions<
    GlacierPolicyApiGetCommercialPropertyCoverageResponse,
    DefaultError,
    GlacierPolicyApiGetCommercialPropertyCoverageResponse,
    ReturnType<typeof glacierPolicyApiGetCommercialPropertyCoverageQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetCommercialPropertyCoverage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetCommercialPropertyCoverageQueryKey(options),
  });

/**
 * Update Cp Coverage
 */
export const glacierPolicyApiUpdateCpCoverageMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateCpCoverageData>>
): UseMutationOptions<
  GlacierPolicyApiUpdateCpCoverageResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateCpCoverageData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateCpCoverageResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateCpCoverageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateCpCoverage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Rate Policy
 */
export const glacierPolicyApiRatePolicyMutation = (
  options?: Partial<Options<GlacierPolicyApiRatePolicyData>>
): UseMutationOptions<
  GlacierPolicyApiRatePolicyResponse,
  GlacierPolicyApiRatePolicyError,
  Options<GlacierPolicyApiRatePolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiRatePolicyResponse,
    GlacierPolicyApiRatePolicyError,
    Options<GlacierPolicyApiRatePolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiRatePolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetFormulasQueryKey = (
  options: Options<GlacierPolicyApiGetFormulasData>
) => createQueryKey('glacierPolicyApiGetFormulas', options);

/**
 * Get Formulas
 */
export const glacierPolicyApiGetFormulasOptions = (
  options: Options<GlacierPolicyApiGetFormulasData>
) =>
  queryOptions<
    GlacierPolicyApiGetFormulasResponse,
    DefaultError,
    GlacierPolicyApiGetFormulasResponse,
    ReturnType<typeof glacierPolicyApiGetFormulasQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetFormulas({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetFormulasQueryKey(options),
  });

/**
 * Create Owned Entities
 */
export const glacierPolicyApiCreateOwnedEntitiesMutation = (
  options?: Partial<Options<GlacierPolicyApiCreateOwnedEntitiesData>>
): UseMutationOptions<
  GlacierPolicyApiCreateOwnedEntitiesResponse,
  DefaultError,
  Options<GlacierPolicyApiCreateOwnedEntitiesData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiCreateOwnedEntitiesResponse,
    DefaultError,
    Options<GlacierPolicyApiCreateOwnedEntitiesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiCreateOwnedEntities({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Owned Entity
 */
export const glacierPolicyApiDeleteOwnedEntityMutation = (
  options?: Partial<Options<GlacierPolicyApiDeleteOwnedEntityData>>
): UseMutationOptions<
  GlacierPolicyApiDeleteOwnedEntityResponse,
  DefaultError,
  Options<GlacierPolicyApiDeleteOwnedEntityData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDeleteOwnedEntityResponse,
    DefaultError,
    Options<GlacierPolicyApiDeleteOwnedEntityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDeleteOwnedEntity({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetOwnedEntityQueryKey = (
  options: Options<GlacierPolicyApiGetOwnedEntityData>
) => createQueryKey('glacierPolicyApiGetOwnedEntity', options);

/**
 * Get Owned Entity
 */
export const glacierPolicyApiGetOwnedEntityOptions = (
  options: Options<GlacierPolicyApiGetOwnedEntityData>
) =>
  queryOptions<
    GlacierPolicyApiGetOwnedEntityResponse,
    DefaultError,
    GlacierPolicyApiGetOwnedEntityResponse,
    ReturnType<typeof glacierPolicyApiGetOwnedEntityQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetOwnedEntity({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetOwnedEntityQueryKey(options),
  });

/**
 * Updated Owned Entity
 */
export const glacierPolicyApiUpdatedOwnedEntityMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdatedOwnedEntityData>>
): UseMutationOptions<
  GlacierPolicyApiUpdatedOwnedEntityResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdatedOwnedEntityData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdatedOwnedEntityResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdatedOwnedEntityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdatedOwnedEntity({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Undo Delete Owned Entity
 */
export const glacierPolicyApiUndoDeleteOwnedEntityMutation = (
  options?: Partial<Options<GlacierPolicyApiUndoDeleteOwnedEntityData>>
): UseMutationOptions<
  GlacierPolicyApiUndoDeleteOwnedEntityResponse,
  DefaultError,
  Options<GlacierPolicyApiUndoDeleteOwnedEntityData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUndoDeleteOwnedEntityResponse,
    DefaultError,
    Options<GlacierPolicyApiUndoDeleteOwnedEntityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUndoDeleteOwnedEntity({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update General Liability
 */
export const glacierPolicyApiUpdateGeneralLiabilityMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateGeneralLiabilityData>>
): UseMutationOptions<
  GlacierPolicyApiUpdateGeneralLiabilityResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateGeneralLiabilityData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateGeneralLiabilityResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateGeneralLiabilityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateGeneralLiability({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Employment Practices Liability
 */
export const glacierPolicyApiUpdateEmploymentPracticesLiabilityMutation = (
  options?: Partial<
    Options<GlacierPolicyApiUpdateEmploymentPracticesLiabilityData>
  >
): UseMutationOptions<
  GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateEmploymentPracticesLiabilityData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateEmploymentPracticesLiabilityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateEmploymentPracticesLiability(
        {
          ...options,
          ...fnOptions,
          throwOnError: true,
        }
      );
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Erisa And Employee Benefits
 */
export const glacierPolicyApiUpdateErisaAndEmployeeBenefitsMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateErisaAndEmployeeBenefitsData>>
): UseMutationOptions<
  GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateErisaAndEmployeeBenefitsData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateErisaAndEmployeeBenefitsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateErisaAndEmployeeBenefits({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetCyberLiabilityQueryKey = (
  options: Options<GlacierPolicyApiGetCyberLiabilityData>
) => createQueryKey('glacierPolicyApiGetCyberLiability', options);

/**
 * Get Cyber Liability
 */
export const glacierPolicyApiGetCyberLiabilityOptions = (
  options: Options<GlacierPolicyApiGetCyberLiabilityData>
) =>
  queryOptions<
    GlacierPolicyApiGetCyberLiabilityResponse,
    DefaultError,
    GlacierPolicyApiGetCyberLiabilityResponse,
    ReturnType<typeof glacierPolicyApiGetCyberLiabilityQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetCyberLiability({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetCyberLiabilityQueryKey(options),
  });

/**
 * Update Cyber Liability
 */
export const glacierPolicyApiUpdateCyberLiabilityMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateCyberLiabilityData>>
): UseMutationOptions<
  GlacierPolicyApiUpdateCyberLiabilityResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateCyberLiabilityData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateCyberLiabilityResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateCyberLiabilityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateCyberLiability({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Issue Policy
 */
export const glacierPolicyApiIssuePolicyMutation = (
  options?: Partial<Options<GlacierPolicyApiIssuePolicyData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiIssuePolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiIssuePolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiIssuePolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetAgentAuthorityQueryKey = (
  options: Options<GlacierPolicyApiGetAgentAuthorityData>
) => createQueryKey('glacierPolicyApiGetAgentAuthority', options);

/**
 * Get Agent Authority
 *
 * Get the agent authority for the policy.
 */
export const glacierPolicyApiGetAgentAuthorityOptions = (
  options: Options<GlacierPolicyApiGetAgentAuthorityData>
) =>
  queryOptions<
    GlacierPolicyApiGetAgentAuthorityResponse,
    DefaultError,
    GlacierPolicyApiGetAgentAuthorityResponse,
    ReturnType<typeof glacierPolicyApiGetAgentAuthorityQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetAgentAuthority({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetAgentAuthorityQueryKey(options),
  });

/**
 * Create Midterm Transaction
 */
export const glacierPolicyApiCreateMidtermTransactionMutation = (
  options?: Partial<Options<GlacierPolicyApiCreateMidtermTransactionData>>
): UseMutationOptions<
  GlacierPolicyApiCreateMidtermTransactionResponse,
  DefaultError,
  Options<GlacierPolicyApiCreateMidtermTransactionData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiCreateMidtermTransactionResponse,
    DefaultError,
    Options<GlacierPolicyApiCreateMidtermTransactionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiCreateMidtermTransaction({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Start Change Expiration Date Midterm
 *
 * Start a "Change Expiration Date" midterm endorsement.
 *
 * Rejects the request if a *bound* child renewal exists. Discards any
 * *in-progress* child renewal before creating the new endorsement, so the
 * renewal will be regenerated against the new expiration date.
 *
 * DC-3260: the entire body runs inside ``transaction.atomic()`` so a
 * later failure (ValueError from start_expiration_date_change, rating
 * error, auto_attach_forms or persist_events failure) rolls back the
 * earlier close_renewal_policy. Otherwise the in-progress child renewal
 * would be permanently closed even when the endorsement attempt failed.
 */
export const glacierPolicyApiStartChangeExpirationDateMidtermMutation = (
  options?: Partial<
    Options<GlacierPolicyApiStartChangeExpirationDateMidtermData>
  >
): UseMutationOptions<
  GlacierPolicyApiStartChangeExpirationDateMidtermResponse,
  DefaultError,
  Options<GlacierPolicyApiStartChangeExpirationDateMidtermData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiStartChangeExpirationDateMidtermResponse,
    DefaultError,
    Options<GlacierPolicyApiStartChangeExpirationDateMidtermData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiStartChangeExpirationDateMidterm({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Change Endorsement Effective Date
 *
 * Change the effective date of an in-progress endorsement transaction.
 *
 * Re-anchors all entities added or soft-deleted during the transaction to the
 * new date. Only allowed for POLICY_ENDORSEMENT transactions while IN_PROGRESS.
 */
export const glacierPolicyApiChangeEndorsementEffectiveDateMutation = (
  options?: Partial<Options<GlacierPolicyApiChangeEndorsementEffectiveDateData>>
): UseMutationOptions<
  GlacierPolicyApiChangeEndorsementEffectiveDateResponse,
  DefaultError,
  Options<GlacierPolicyApiChangeEndorsementEffectiveDateData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiChangeEndorsementEffectiveDateResponse,
    DefaultError,
    Options<GlacierPolicyApiChangeEndorsementEffectiveDateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiChangeEndorsementEffectiveDate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set Reason For Change
 *
 * Persist the endorsement "reason for change" from the pricing-preview autosave.
 *
 * Driven by mountaineer's PricingPreview autosave (and manual save) on the policy
 * pricing-preview screen. "Reason for change" only applies to an in-progress endorsement,
 * so when the current transaction is not an in-progress ``POLICY_ENDORSEMENT`` (e.g. a
 * debounced autosave that lands after the endorsement was finalized/bound/cancelled, or a
 * non-endorsement transaction) this returns a benign ``200 {"success": True, "skipped":
 * True}`` no-op instead of a 500 — nothing is persisted, and ``skipped`` flags that. See
 * DP1-3796 / Sentry ASPEN-DENTAL-1DS. Genuine failures on the persist path still return a
 * 500 so they stay visible to error monitoring.
 *
 * NOTE: frontend consumers should honor ``skipped`` (avoid the success toast / optimistic
 * cache write) so an unpersisted value is not shown as saved — tracked as a mountaineer
 * follow-up.
 */
export const glacierPolicyApiSetReasonForChangeMutation = (
  options?: Partial<Options<GlacierPolicyApiSetReasonForChangeData>>
): UseMutationOptions<
  GlacierPolicyApiSetReasonForChangeResponse,
  DefaultError,
  Options<GlacierPolicyApiSetReasonForChangeData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiSetReasonForChangeResponse,
    DefaultError,
    Options<GlacierPolicyApiSetReasonForChangeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiSetReasonForChange({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiPricePreviewMidtermChangeQueryKey = (
  options: Options<GlacierPolicyApiPricePreviewMidtermChangeData>
) => createQueryKey('glacierPolicyApiPricePreviewMidtermChange', options);

/**
 * Price Preview Midterm Change
 */
export const glacierPolicyApiPricePreviewMidtermChangeOptions = (
  options: Options<GlacierPolicyApiPricePreviewMidtermChangeData>
) =>
  queryOptions<
    GlacierPolicyApiPricePreviewMidtermChangeResponse,
    DefaultError,
    GlacierPolicyApiPricePreviewMidtermChangeResponse,
    ReturnType<typeof glacierPolicyApiPricePreviewMidtermChangeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiPricePreviewMidtermChange({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiPricePreviewMidtermChangeQueryKey(options),
  });

export const glacierPolicyApiReasonForChangePreviewQueryKey = (
  options: Options<GlacierPolicyApiReasonForChangePreviewData>
) => createQueryKey('glacierPolicyApiReasonForChangePreview', options);

/**
 * Reason For Change Preview
 *
 * Generate auto-populated "Reason for Change" verbiage from the midterm diff.
 *
 * DC-3224. Computes the diff between the previous and current (in-progress)
 * transaction by reusing the same engine that powers the Summary of Changes (no side
 * effects, read-only), then maps each relevant change to its Aspen-spec phrase.
 * Changes with no spec phrase contribute nothing (the list can come back empty).
 *
 * Read-only, so it uses ``FastPolicy`` + the policy-view etag cache like the sibling
 * price-preview on the same screen (the verbiage is a pure function of the policy
 * events, so the sequence-number etag invalidates exactly when it should).
 */
export const glacierPolicyApiReasonForChangePreviewOptions = (
  options: Options<GlacierPolicyApiReasonForChangePreviewData>
) =>
  queryOptions<
    GlacierPolicyApiReasonForChangePreviewResponse,
    DefaultError,
    GlacierPolicyApiReasonForChangePreviewResponse,
    ReturnType<typeof glacierPolicyApiReasonForChangePreviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiReasonForChangePreview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiReasonForChangePreviewQueryKey(options),
  });

/**
 * Finalize Midterm Change
 *
 * Validate permissions and required fields, run the finalize commands, and
 * persist the transaction. Domain (`ValueError`) and unexpected failures are
 * both converted to a 400 rather than an opaque 500.
 */
export const glacierPolicyApiFinalizeMidtermChangeMutation = (
  options?: Partial<Options<GlacierPolicyApiFinalizeMidtermChangeData>>
): UseMutationOptions<
  GlacierPolicyApiFinalizeMidtermChangeResponse,
  DefaultError,
  Options<GlacierPolicyApiFinalizeMidtermChangeData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiFinalizeMidtermChangeResponse,
    DefaultError,
    Options<GlacierPolicyApiFinalizeMidtermChangeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiFinalizeMidtermChange({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Cancel Midterm Change
 */
export const glacierPolicyApiCancelMidtermChangeMutation = (
  options?: Partial<Options<GlacierPolicyApiCancelMidtermChangeData>>
): UseMutationOptions<
  GlacierPolicyApiCancelMidtermChangeResponse,
  DefaultError,
  Options<GlacierPolicyApiCancelMidtermChangeData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiCancelMidtermChangeResponse,
    DefaultError,
    Options<GlacierPolicyApiCancelMidtermChangeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiCancelMidtermChange({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetSummaryOfChangesPdfQueryKey = (
  options: Options<GlacierPolicyApiGetSummaryOfChangesPdfData>
) => createQueryKey('glacierPolicyApiGetSummaryOfChangesPdf', options);

/**
 * Get Summary Of Changes Pdf
 *
 * Generate and return the Summary of Changes PDF for a policy without saving it.
 *
 * This endpoint generates the Summary of Changes document by comparing the current
 * transaction with the previous transaction, but does not create any events or
 * persist the file to the database.
 */
export const glacierPolicyApiGetSummaryOfChangesPdfOptions = (
  options: Options<GlacierPolicyApiGetSummaryOfChangesPdfData>
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof glacierPolicyApiGetSummaryOfChangesPdfQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetSummaryOfChangesPdf({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetSummaryOfChangesPdfQueryKey(options),
  });

/**
 * Revert Transaction
 */
export const glacierPolicyApiRevertTransactionMutation = (
  options?: Partial<Options<GlacierPolicyApiRevertTransactionData>>
): UseMutationOptions<
  GlacierPolicyApiRevertTransactionResponse,
  DefaultError,
  Options<GlacierPolicyApiRevertTransactionData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiRevertTransactionResponse,
    DefaultError,
    Options<GlacierPolicyApiRevertTransactionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiRevertTransaction({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Dentist Underwriting Questions
 */
export const glacierPolicyApiUpdateDentistUnderwritingQuestionsMutation = (
  options?: Partial<
    Options<GlacierPolicyApiUpdateDentistUnderwritingQuestionsData>
  >
): UseMutationOptions<
  GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateDentistUnderwritingQuestionsData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateDentistUnderwritingQuestionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateDentistUnderwritingQuestions(
        {
          ...options,
          ...fnOptions,
          throwOnError: true,
        }
      );
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Premium Statement
 */
export const glacierPolicyApiPremiumStatementMutation = (
  options?: Partial<Options<GlacierPolicyApiPremiumStatementData>>
): UseMutationOptions<
  GlacierPolicyApiPremiumStatementResponse,
  DefaultError,
  Options<GlacierPolicyApiPremiumStatementData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiPremiumStatementResponse,
    DefaultError,
    Options<GlacierPolicyApiPremiumStatementData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiPremiumStatement({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Agency Bill Invoice
 */
export const glacierPolicyApiAgencyBillInvoiceMutation = (
  options?: Partial<Options<GlacierPolicyApiAgencyBillInvoiceData>>
): UseMutationOptions<
  GlacierPolicyApiAgencyBillInvoiceResponse,
  DefaultError,
  Options<GlacierPolicyApiAgencyBillInvoiceData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiAgencyBillInvoiceResponse,
    DefaultError,
    Options<GlacierPolicyApiAgencyBillInvoiceData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiAgencyBillInvoice({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Get Special Forms
 */
export const glacierPolicyApiGetSpecialFormsMutation = (
  options?: Partial<Options<GlacierPolicyApiGetSpecialFormsData>>
): UseMutationOptions<
  GlacierPolicyApiGetSpecialFormsResponse,
  DefaultError,
  Options<GlacierPolicyApiGetSpecialFormsData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiGetSpecialFormsResponse,
    DefaultError,
    Options<GlacierPolicyApiGetSpecialFormsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiGetSpecialForms({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Conditional Renewal Notice
 */
export const glacierPolicyApiConditionalRenewalNoticeMutation = (
  options?: Partial<Options<GlacierPolicyApiConditionalRenewalNoticeData>>
): UseMutationOptions<
  GlacierPolicyApiConditionalRenewalNoticeResponse,
  DefaultError,
  Options<GlacierPolicyApiConditionalRenewalNoticeData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiConditionalRenewalNoticeResponse,
    DefaultError,
    Options<GlacierPolicyApiConditionalRenewalNoticeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiConditionalRenewalNotice({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Download Rating Worksheets
 */
export const glacierPolicyApiDownloadRatingWorksheetsMutation = (
  options?: Partial<Options<GlacierPolicyApiDownloadRatingWorksheetsData>>
): UseMutationOptions<
  GlacierPolicyApiDownloadRatingWorksheetsResponse,
  DefaultError,
  Options<GlacierPolicyApiDownloadRatingWorksheetsData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDownloadRatingWorksheetsResponse,
    DefaultError,
    Options<GlacierPolicyApiDownloadRatingWorksheetsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDownloadRatingWorksheets({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Download Erp Worksheets
 *
 * Generate and download ERP worksheets.
 *
 * This endpoint generates ERP worksheets using ODT templates stored in S3.
 * Currently supports ERP Estimate worksheets for midterm endorsements and cancellations.
 */
export const glacierPolicyApiDownloadErpWorksheetsMutation = (
  options?: Partial<Options<GlacierPolicyApiDownloadErpWorksheetsData>>
): UseMutationOptions<
  GlacierPolicyApiDownloadErpWorksheetsResponse,
  DefaultError,
  Options<GlacierPolicyApiDownloadErpWorksheetsData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDownloadErpWorksheetsResponse,
    DefaultError,
    Options<GlacierPolicyApiDownloadErpWorksheetsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDownloadErpWorksheets({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Premium Renewal Notice
 */
export const glacierPolicyApiPremiumRenewalNoticeMutation = (
  options?: Partial<Options<GlacierPolicyApiPremiumRenewalNoticeData>>
): UseMutationOptions<
  GlacierPolicyApiPremiumRenewalNoticeResponse,
  DefaultError,
  Options<GlacierPolicyApiPremiumRenewalNoticeData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiPremiumRenewalNoticeResponse,
    DefaultError,
    Options<GlacierPolicyApiPremiumRenewalNoticeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiPremiumRenewalNotice({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Download Looker Dashboard Pdf
 *
 * Loss runs as a rendered PDF of the Looker dashboard.
 *
 * `data.loss_run_type` picks the slice of the claims report: liability
 * (Counterpart-handled claims) or property (Carrier-handled).
 */
export const glacierPolicyApiDownloadLookerDashboardPdfMutation = (
  options?: Partial<Options<GlacierPolicyApiDownloadLookerDashboardPdfData>>
): UseMutationOptions<
  GlacierPolicyApiDownloadLookerDashboardPdfResponse,
  DefaultError,
  Options<GlacierPolicyApiDownloadLookerDashboardPdfData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDownloadLookerDashboardPdfResponse,
    DefaultError,
    Options<GlacierPolicyApiDownloadLookerDashboardPdfData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDownloadLookerDashboardPdf({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Download Looker Dashboard Csv
 *
 * Loss runs as a ZIP of one CSV per dashboard tile.
 *
 * `data.loss_run_type` picks the slice of the claims report: liability
 * (Counterpart-handled claims) or property (Carrier-handled).
 */
export const glacierPolicyApiDownloadLookerDashboardCsvMutation = (
  options?: Partial<Options<GlacierPolicyApiDownloadLookerDashboardCsvData>>
): UseMutationOptions<
  GlacierPolicyApiDownloadLookerDashboardCsvResponse,
  DefaultError,
  Options<GlacierPolicyApiDownloadLookerDashboardCsvData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDownloadLookerDashboardCsvResponse,
    DefaultError,
    Options<GlacierPolicyApiDownloadLookerDashboardCsvData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDownloadLookerDashboardCsv({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiSpecimenPreviewQueryKey = (
  options: Options<GlacierPolicyApiSpecimenPreviewData>
) => createQueryKey('glacierPolicyApiSpecimenPreview', options);

/**
 * Specimen Preview
 */
export const glacierPolicyApiSpecimenPreviewOptions = (
  options: Options<GlacierPolicyApiSpecimenPreviewData>
) =>
  queryOptions<
    GlacierPolicyApiSpecimenPreviewResponse,
    DefaultError,
    GlacierPolicyApiSpecimenPreviewResponse,
    ReturnType<typeof glacierPolicyApiSpecimenPreviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiSpecimenPreview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiSpecimenPreviewQueryKey(options),
  });

export const glacierPolicyApiListDocumentsQueryKey = (
  options: Options<GlacierPolicyApiListDocumentsData>
) => createQueryKey('glacierPolicyApiListDocuments', options);

/**
 * List Documents
 */
export const glacierPolicyApiListDocumentsOptions = (
  options: Options<GlacierPolicyApiListDocumentsData>
) =>
  queryOptions<
    GlacierPolicyApiListDocumentsResponse,
    DefaultError,
    GlacierPolicyApiListDocumentsResponse,
    ReturnType<typeof glacierPolicyApiListDocumentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiListDocuments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiListDocumentsQueryKey(options),
  });

/**
 * Upload Document
 */
export const glacierPolicyApiUploadDocumentMutation = (
  options?: Partial<Options<GlacierPolicyApiUploadDocumentData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiUploadDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiUploadDocumentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUploadDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiDownloadAllTransactionsDocumentsQueryKey = (
  options: Options<GlacierPolicyApiDownloadAllTransactionsDocumentsData>
) =>
  createQueryKey('glacierPolicyApiDownloadAllTransactionsDocuments', options);

/**
 * Download All Transactions Documents
 *
 * Compile every committed transaction's policy documents into a single ordered PDF --
 * see ``glacier.policy.all_transactions_bundle``.
 */
export const glacierPolicyApiDownloadAllTransactionsDocumentsOptions = (
  options: Options<GlacierPolicyApiDownloadAllTransactionsDocumentsData>
) =>
  queryOptions<
    GlacierPolicyApiDownloadAllTransactionsDocumentsResponse,
    DefaultError,
    GlacierPolicyApiDownloadAllTransactionsDocumentsResponse,
    ReturnType<typeof glacierPolicyApiDownloadAllTransactionsDocumentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiDownloadAllTransactionsDocuments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiDownloadAllTransactionsDocumentsQueryKey(options),
  });

/**
 * Upload Documents With Metadata
 *
 * Upload one or more documents with optional per-file metadata.
 *
 * Files are sent as multipart `files` fields.
 * Metadata is a JSON array of objects, one per file (matched by index):
 * [{"filename": "...", "description": "...", "category": "...", "subcategory": "..."}, ...]
 * All metadata fields are optional. If metadata array is shorter than files, remaining files
 * get defaults. Maximum 30 files per request.
 */
export const glacierPolicyApiUploadDocumentsWithMetadataMutation = (
  options?: Partial<Options<GlacierPolicyApiUploadDocumentsWithMetadataData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiUploadDocumentsWithMetadataData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiUploadDocumentsWithMetadataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUploadDocumentsWithMetadata({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Detach Document
 */
export const glacierPolicyApiDetachDocumentMutation = (
  options?: Partial<Options<GlacierPolicyApiDetachDocumentData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiDetachDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiDetachDocumentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDetachDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Document
 */
export const glacierPolicyApiUpdateDocumentMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateDocumentData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiUpdateDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiUpdateDocumentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const documentIsReadyQueryKey = (
  options: Options<DocumentIsReadyData>
) => createQueryKey('documentIsReady', options);

/**
 * Document Is Ready
 *
 * Check if a document is already rendered
 * Returns status 200 with status 200 if the document is ready, 404 with status 404 if it is not.
 */
export const documentIsReadyOptions = (options: Options<DocumentIsReadyData>) =>
  queryOptions<
    DocumentIsReadyResponse,
    DocumentIsReadyError,
    DocumentIsReadyResponse,
    ReturnType<typeof documentIsReadyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await documentIsReady({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: documentIsReadyQueryKey(options),
  });

export const glacierPolicyApiDownloadDocumentQueryKey = (
  options: Options<GlacierPolicyApiDownloadDocumentData>
) => createQueryKey('glacierPolicyApiDownloadDocument', options);

/**
 * Download Document
 */
export const glacierPolicyApiDownloadDocumentOptions = (
  options: Options<GlacierPolicyApiDownloadDocumentData>
) =>
  queryOptions<
    GlacierPolicyApiDownloadDocumentResponse,
    DefaultError,
    GlacierPolicyApiDownloadDocumentResponse,
    ReturnType<typeof glacierPolicyApiDownloadDocumentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiDownloadDocument({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiDownloadDocumentQueryKey(options),
  });

/**
 * Regenerate Document
 */
export const glacierPolicyApiRegenerateDocumentMutation = (
  options?: Partial<Options<GlacierPolicyApiRegenerateDocumentData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiRegenerateDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiRegenerateDocumentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiRegenerateDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Regenerate Complete Policy Bundle
 *
 * Regenerate complete policy bundle for midterm transactions.
 *
 * This endpoint allows Underwriting Admins to regenerate a complete policy bundle
 * with ALL forms from all transactions.
 *
 * Requirements:
 * - User must be Underwriting Admin
 * - Document must be a POLICY_BUNDLE
 * - Transaction must be ACTIVE (committed)
 * - Transaction type must be ENDORSEMENT or REINSTATED
 *
 * Args:
 * document_id: UUID of the document to regenerate
 * policy_id: UUID of the policy
 *
 * Returns:
 * 204 on success
 *
 * Raises:
 * HttpError 403: User not authorized
 * HttpError 400: Validation error (wrong document type, transaction status, or type)
 * HttpError 404: Document not found
 * HttpError 500: Internal server error
 */
export const glacierPolicyApiRegenerateCompletePolicyBundleMutation = (
  options?: Partial<Options<GlacierPolicyApiRegenerateCompletePolicyBundleData>>
): UseMutationOptions<
  GlacierPolicyApiRegenerateCompletePolicyBundleResponse,
  DefaultError,
  Options<GlacierPolicyApiRegenerateCompletePolicyBundleData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiRegenerateCompletePolicyBundleResponse,
    DefaultError,
    Options<GlacierPolicyApiRegenerateCompletePolicyBundleData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiRegenerateCompletePolicyBundle({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Commit Transaction Test
 */
export const glacierPolicyApiCommitTransactionTestMutation = (
  options?: Partial<Options<GlacierPolicyApiCommitTransactionTestData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiCommitTransactionTestData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiCommitTransactionTestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiCommitTransactionTest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiListUnderwriterNotesQueryKey = (
  options: Options<GlacierPolicyApiListUnderwriterNotesData>
) => createQueryKey('glacierPolicyApiListUnderwriterNotes', options);

/**
 * List Underwriter Notes
 */
export const glacierPolicyApiListUnderwriterNotesOptions = (
  options: Options<GlacierPolicyApiListUnderwriterNotesData>
) =>
  queryOptions<
    GlacierPolicyApiListUnderwriterNotesResponse,
    DefaultError,
    GlacierPolicyApiListUnderwriterNotesResponse,
    ReturnType<typeof glacierPolicyApiListUnderwriterNotesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiListUnderwriterNotes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiListUnderwriterNotesQueryKey(options),
  });

/**
 * Create Underwriter Notes
 */
export const glacierPolicyApiCreateUnderwriterNotesMutation = (
  options?: Partial<Options<GlacierPolicyApiCreateUnderwriterNotesData>>
): UseMutationOptions<
  GlacierPolicyApiCreateUnderwriterNotesResponse,
  DefaultError,
  Options<GlacierPolicyApiCreateUnderwriterNotesData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiCreateUnderwriterNotesResponse,
    DefaultError,
    Options<GlacierPolicyApiCreateUnderwriterNotesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiCreateUnderwriterNotes({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Underwriter Notes
 */
export const glacierPolicyApiDeleteUnderwriterNotesMutation = (
  options?: Partial<Options<GlacierPolicyApiDeleteUnderwriterNotesData>>
): UseMutationOptions<
  GlacierPolicyApiDeleteUnderwriterNotesResponse,
  DefaultError,
  Options<GlacierPolicyApiDeleteUnderwriterNotesData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDeleteUnderwriterNotesResponse,
    DefaultError,
    Options<GlacierPolicyApiDeleteUnderwriterNotesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDeleteUnderwriterNotes({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Underwriter Notes
 */
export const glacierPolicyApiUpdateUnderwriterNotesMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateUnderwriterNotesData>>
): UseMutationOptions<
  GlacierPolicyApiUpdateUnderwriterNotesResponse,
  DefaultError,
  Options<GlacierPolicyApiUpdateUnderwriterNotesData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateUnderwriterNotesResponse,
    DefaultError,
    Options<GlacierPolicyApiUpdateUnderwriterNotesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiUpdateUnderwriterNotes({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Reopen Unlocked Account
 *
 * Endpoint to reopen an unlocked account for system admin users.
 * Sets quote_type back to None and erases the policy_number.
 */
export const glacierPolicyApiReopenUnlockedAccountMutation = (
  options?: Partial<Options<GlacierPolicyApiReopenUnlockedAccountData>>
): UseMutationOptions<
  GlacierPolicyApiReopenUnlockedAccountResponse,
  GlacierPolicyApiReopenUnlockedAccountError,
  Options<GlacierPolicyApiReopenUnlockedAccountData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiReopenUnlockedAccountResponse,
    GlacierPolicyApiReopenUnlockedAccountError,
    Options<GlacierPolicyApiReopenUnlockedAccountData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiReopenUnlockedAccount({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Policy Pending Cancellation Transaction
 */
export const glacierPolicyApiCreatePolicyPendingCancellationTransactionMutation =
  (
    options?: Partial<
      Options<GlacierPolicyApiCreatePolicyPendingCancellationTransactionData>
    >
  ): UseMutationOptions<
    GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponse,
    DefaultError,
    Options<GlacierPolicyApiCreatePolicyPendingCancellationTransactionData>
  > => {
    const mutationOptions: UseMutationOptions<
      GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponse,
      DefaultError,
      Options<GlacierPolicyApiCreatePolicyPendingCancellationTransactionData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await glacierPolicyApiCreatePolicyPendingCancellationTransaction({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

export const glacierPolicyApiListObjectSummariesQueryKey = (
  options: Options<GlacierPolicyApiListObjectSummariesData>
) => createQueryKey('glacierPolicyApiListObjectSummaries', options);

/**
 * List Object Summaries
 */
export const glacierPolicyApiListObjectSummariesOptions = (
  options: Options<GlacierPolicyApiListObjectSummariesData>
) =>
  queryOptions<
    GlacierPolicyApiListObjectSummariesResponse,
    DefaultError,
    GlacierPolicyApiListObjectSummariesResponse,
    ReturnType<typeof glacierPolicyApiListObjectSummariesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiListObjectSummaries({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiListObjectSummariesQueryKey(options),
  });

export const glacierPolicyApiGetObjectDetailsQueryKey = (
  options: Options<GlacierPolicyApiGetObjectDetailsData>
) => createQueryKey('glacierPolicyApiGetObjectDetails', options);

/**
 * Get Object Details
 */
export const glacierPolicyApiGetObjectDetailsOptions = (
  options: Options<GlacierPolicyApiGetObjectDetailsData>
) =>
  queryOptions<
    GlacierPolicyApiGetObjectDetailsResponse,
    DefaultError,
    GlacierPolicyApiGetObjectDetailsResponse,
    ReturnType<typeof glacierPolicyApiGetObjectDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetObjectDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetObjectDetailsQueryKey(options),
  });

/**
 * Refer Policy
 *
 * Refer a policy to the agency's designated referral underwriter.
 *
 * Optionally attaches an agent note (stored as an UnderwriterNote with
 * source=REFERRAL) that the underwriter can review.
 */
export const glacierPolicyApiReferPolicyMutation = (
  options?: Partial<Options<GlacierPolicyApiReferPolicyData>>
): UseMutationOptions<
  GlacierPolicyApiReferPolicyResponse,
  GlacierPolicyApiReferPolicyError,
  Options<GlacierPolicyApiReferPolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiReferPolicyResponse,
    GlacierPolicyApiReferPolicyError,
    Options<GlacierPolicyApiReferPolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiReferPolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiListTransactionsQueryKey = (
  options: Options<GlacierPolicyApiListTransactionsData>
) => createQueryKey('glacierPolicyApiListTransactions', options);

/**
 * List Transactions
 *
 * Get all transaction snapshots for a policy for Time Travel functionality.
 * Each snapshot represents the final state of a transaction that users can navigate to.
 * Returns snapshots ordered by transaction number (newest first).
 */
export const glacierPolicyApiListTransactionsOptions = (
  options: Options<GlacierPolicyApiListTransactionsData>
) =>
  queryOptions<
    GlacierPolicyApiListTransactionsResponse,
    DefaultError,
    GlacierPolicyApiListTransactionsResponse,
    ReturnType<typeof glacierPolicyApiListTransactionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiListTransactions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiListTransactionsQueryKey(options),
  });

export const glacierPolicyApiGetTransactionSummaryQueryKey = (
  options: Options<GlacierPolicyApiGetTransactionSummaryData>
) => createQueryKey('glacierPolicyApiGetTransactionSummary', options);

/**
 * Get Transaction Summary
 *
 * Get the summary of changes for a specific transaction.
 *
 * Returns the diff between the previous and current transaction,
 * showing what changed when the transaction was committed.
 *
 * Supports both same-policy comparisons (typical midterm changes)
 * and cross-policy comparisons (renewals, rollovers).
 */
export const glacierPolicyApiGetTransactionSummaryOptions = (
  options: Options<GlacierPolicyApiGetTransactionSummaryData>
) =>
  queryOptions<
    GlacierPolicyApiGetTransactionSummaryResponse,
    DefaultError,
    GlacierPolicyApiGetTransactionSummaryResponse,
    ReturnType<typeof glacierPolicyApiGetTransactionSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetTransactionSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetTransactionSummaryQueryKey(options),
  });

export const glacierPolicyApiGetTransactionDetailQueryKey = (
  options: Options<GlacierPolicyApiGetTransactionDetailData>
) => createQueryKey('glacierPolicyApiGetTransactionDetail', options);

/**
 * Get Transaction Detail
 *
 * Get transaction detail for Time Travel functionality.
 * Returns transaction details and assigned user information.
 * This allows users to view the transaction details for a specific transaction number.
 * Unlike other endpoints, this one always uses the transaction_number from the URL parameter,
 * not from request headers.
 */
export const glacierPolicyApiGetTransactionDetailOptions = (
  options: Options<GlacierPolicyApiGetTransactionDetailData>
) =>
  queryOptions<
    GlacierPolicyApiGetTransactionDetailResponse,
    DefaultError,
    GlacierPolicyApiGetTransactionDetailResponse,
    ReturnType<typeof glacierPolicyApiGetTransactionDetailQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetTransactionDetail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetTransactionDetailQueryKey(options),
  });

/**
 * Confirm Rating Checks
 */
export const glacierPolicyApiConfirmRatingChecksMutation = (
  options?: Partial<Options<GlacierPolicyApiConfirmRatingChecksData>>
): UseMutationOptions<
  GlacierPolicyApiConfirmRatingChecksResponse,
  DefaultError,
  Options<GlacierPolicyApiConfirmRatingChecksData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiConfirmRatingChecksResponse,
    DefaultError,
    Options<GlacierPolicyApiConfirmRatingChecksData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiConfirmRatingChecks({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Policy Renewal Flag
 */
export const glacierPolicyApiDeletePolicyRenewalFlagMutation = (
  options?: Partial<Options<GlacierPolicyApiDeletePolicyRenewalFlagData>>
): UseMutationOptions<
  GlacierPolicyApiDeletePolicyRenewalFlagResponse,
  DefaultError,
  Options<GlacierPolicyApiDeletePolicyRenewalFlagData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDeletePolicyRenewalFlagResponse,
    DefaultError,
    Options<GlacierPolicyApiDeletePolicyRenewalFlagData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiDeletePolicyRenewalFlag({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set Policy Renewal Flag
 */
export const glacierPolicyApiSetPolicyRenewalFlagMutation = (
  options?: Partial<Options<GlacierPolicyApiSetPolicyRenewalFlagData>>
): UseMutationOptions<
  GlacierPolicyApiSetPolicyRenewalFlagResponse,
  DefaultError,
  Options<GlacierPolicyApiSetPolicyRenewalFlagData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiSetPolicyRenewalFlagResponse,
    DefaultError,
    Options<GlacierPolicyApiSetPolicyRenewalFlagData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiSetPolicyRenewalFlag({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetChildPolicyQueryKey = (
  options: Options<GlacierPolicyApiGetChildPolicyData>
) => createQueryKey('glacierPolicyApiGetChildPolicy', options);

/**
 * Get Child Policy
 */
export const glacierPolicyApiGetChildPolicyOptions = (
  options: Options<GlacierPolicyApiGetChildPolicyData>
) =>
  queryOptions<
    GlacierPolicyApiGetChildPolicyResponse,
    DefaultError,
    GlacierPolicyApiGetChildPolicyResponse,
    ReturnType<typeof glacierPolicyApiGetChildPolicyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetChildPolicy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetChildPolicyQueryKey(options),
  });

export const glacierPolicyApiGetPolicyTermsQueryKey = (
  options: Options<GlacierPolicyApiGetPolicyTermsData>
) => createQueryKey('glacierPolicyApiGetPolicyTerms', options);

/**
 * Get Policy Terms
 *
 * Return every term in the renewal chain ``account_id`` belongs to (DC-3253).
 *
 * Terms in a chain share a ``policyholder_id`` (the root term's account_id),
 * so the whole chain resolves in a single query -- no client-side chain
 * walking. Ordered most-recent-first for the dropdown; ``term_number`` is the
 * chronological ordinal (Term 1 = oldest). Non-staff are scoped to their own
 * agencies' terms via ``user_permission_qs`` (DC-3454).
 */
export const glacierPolicyApiGetPolicyTermsOptions = (
  options: Options<GlacierPolicyApiGetPolicyTermsData>
) =>
  queryOptions<
    GlacierPolicyApiGetPolicyTermsResponse,
    DefaultError,
    GlacierPolicyApiGetPolicyTermsResponse,
    ReturnType<typeof glacierPolicyApiGetPolicyTermsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPolicyTerms({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPolicyTermsQueryKey(options),
  });

/**
 * Create Renewal
 *
 * Creates the renewal policy from this policy
 */
export const glacierPolicyApiCreateRenewalMutation = (
  options?: Partial<Options<GlacierPolicyApiCreateRenewalData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiCreateRenewalData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiCreateRenewalData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiCreateRenewal({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Close Renewal
 *
 * Closes (discards) a renewal policy.
 * Must be called on the renewal policy itself, not the parent.
 */
export const glacierPolicyApiCloseRenewalMutation = (
  options?: Partial<Options<GlacierPolicyApiCloseRenewalData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyApiCloseRenewalData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyApiCloseRenewalData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyApiCloseRenewal({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiRenewalSummaryOfChangesQueryKey = (
  options: Options<GlacierPolicyApiRenewalSummaryOfChangesData>
) => createQueryKey('glacierPolicyApiRenewalSummaryOfChanges', options);

/**
 * Renewal Summary Of Changes
 *
 * Generate and return the Summary of Changes PDF for a renewal policy without saving it.
 *
 * This endpoint generates the Summary of Changes document by comparing the renewal
 * policy with its parent policy, but does not create any events or persist the file
 * to the database. Must be called on the renewal policy itself, not the parent.
 */
export const glacierPolicyApiRenewalSummaryOfChangesOptions = (
  options: Options<GlacierPolicyApiRenewalSummaryOfChangesData>
) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof glacierPolicyApiRenewalSummaryOfChangesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiRenewalSummaryOfChanges({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiRenewalSummaryOfChangesQueryKey(options),
  });

export const glacierPolicyFormsApiPolicyLevelAttachedEndorsementsQueryKey = (
  options: Options<GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsData>
) =>
  createQueryKey(
    'glacierPolicyFormsApiPolicyLevelAttachedEndorsements',
    options
  );

/**
 * Policy Level Attached Endorsements
 *
 * Return all the attached endorsements at the policy level.
 *
 * When ``include_superseded`` is False (default) superseded forms are dropped
 * via ``deduplicate_attached_forms``; when True the deduped set is expanded to
 * also include actual supersession targets (see ``_listed_forms``) so
 * superseded entries are visible -- legacy same-``form_id`` duplicates with no
 * supersession link stay hidden either way. ``is_superseded`` /
 * ``superseded_by_transaction_number`` are computed over each entity's RAW
 * forms in both modes (the factory always receives ``*.attached_forms``).
 */
export const glacierPolicyFormsApiPolicyLevelAttachedEndorsementsOptions = (
  options: Options<GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsData>
) =>
  queryOptions<
    GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsResponse,
    DefaultError,
    GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsResponse,
    ReturnType<
      typeof glacierPolicyFormsApiPolicyLevelAttachedEndorsementsQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyFormsApiPolicyLevelAttachedEndorsements({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyFormsApiPolicyLevelAttachedEndorsementsQueryKey(options),
  });

/**
 * Attach Form To Policy
 */
export const glacierPolicyFormsApiAttachFormToPolicyMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiAttachFormToPolicyData>>
): UseMutationOptions<
  GlacierPolicyFormsApiAttachFormToPolicyResponse,
  DefaultError,
  Options<GlacierPolicyFormsApiAttachFormToPolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiAttachFormToPolicyResponse,
    DefaultError,
    Options<GlacierPolicyFormsApiAttachFormToPolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyFormsApiAttachFormToPolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Detach Form From Policy
 */
export const glacierPolicyFormsApiDetachFormFromPolicyMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiDetachFormFromPolicyData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyFormsApiDetachFormFromPolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyFormsApiDetachFormFromPolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyFormsApiDetachFormFromPolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetAvailableEndorsementsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetAvailableEndorsementsData>
) => createQueryKey('glacierPolicyFormsApiGetAvailableEndorsements', options);

/**
 * Get Available Endorsements
 */
export const glacierPolicyFormsApiGetAvailableEndorsementsOptions = (
  options: Options<GlacierPolicyFormsApiGetAvailableEndorsementsData>
) =>
  queryOptions<
    GlacierPolicyFormsApiGetAvailableEndorsementsResponse,
    DefaultError,
    GlacierPolicyFormsApiGetAvailableEndorsementsResponse,
    ReturnType<typeof glacierPolicyFormsApiGetAvailableEndorsementsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetAvailableEndorsements({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetAvailableEndorsementsQueryKey(options),
  });

/**
 * Attach Form To Dentist
 */
export const glacierPolicyFormsApiAttachFormToDentistMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiAttachFormToDentistData>>
): UseMutationOptions<
  GlacierPolicyFormsApiAttachFormToDentistResponse,
  DefaultError,
  Options<GlacierPolicyFormsApiAttachFormToDentistData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiAttachFormToDentistResponse,
    DefaultError,
    Options<GlacierPolicyFormsApiAttachFormToDentistData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyFormsApiAttachFormToDentist({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Detach Form From Dentist
 */
export const glacierPolicyFormsApiDetachFormFromDentistMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiDetachFormFromDentistData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyFormsApiDetachFormFromDentistData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyFormsApiDetachFormFromDentistData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyFormsApiDetachFormFromDentist({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetDentistAttachedFormsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetDentistAttachedFormsData>
) => createQueryKey('glacierPolicyFormsApiGetDentistAttachedForms', options);

/**
 * Get Dentist Attached Forms
 */
export const glacierPolicyFormsApiGetDentistAttachedFormsOptions = (
  options: Options<GlacierPolicyFormsApiGetDentistAttachedFormsData>
) =>
  queryOptions<
    GlacierPolicyFormsApiGetDentistAttachedFormsResponse,
    DefaultError,
    GlacierPolicyFormsApiGetDentistAttachedFormsResponse,
    ReturnType<typeof glacierPolicyFormsApiGetDentistAttachedFormsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetDentistAttachedForms({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetDentistAttachedFormsQueryKey(options),
  });

export const glacierPolicyFormsApiGetDentistAvailableEndorsementsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetDentistAvailableEndorsementsData>
) =>
  createQueryKey(
    'glacierPolicyFormsApiGetDentistAvailableEndorsements',
    options
  );

/**
 * Get Dentist Available Endorsements
 */
export const glacierPolicyFormsApiGetDentistAvailableEndorsementsOptions = (
  options: Options<GlacierPolicyFormsApiGetDentistAvailableEndorsementsData>
) =>
  queryOptions<
    GlacierPolicyFormsApiGetDentistAvailableEndorsementsResponse,
    DefaultError,
    GlacierPolicyFormsApiGetDentistAvailableEndorsementsResponse,
    ReturnType<
      typeof glacierPolicyFormsApiGetDentistAvailableEndorsementsQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyFormsApiGetDentistAvailableEndorsements({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyFormsApiGetDentistAvailableEndorsementsQueryKey(options),
  });

/**
 * Attach Form To Location
 */
export const glacierPolicyFormsApiAttachFormToLocationMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiAttachFormToLocationData>>
): UseMutationOptions<
  GlacierPolicyFormsApiAttachFormToLocationResponse,
  DefaultError,
  Options<GlacierPolicyFormsApiAttachFormToLocationData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiAttachFormToLocationResponse,
    DefaultError,
    Options<GlacierPolicyFormsApiAttachFormToLocationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyFormsApiAttachFormToLocation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Detach Form From Location
 */
export const glacierPolicyFormsApiDetachFormFromLocationMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiDetachFormFromLocationData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyFormsApiDetachFormFromLocationData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyFormsApiDetachFormFromLocationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyFormsApiDetachFormFromLocation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetLocationAttachedFormsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetLocationAttachedFormsData>
) => createQueryKey('glacierPolicyFormsApiGetLocationAttachedForms', options);

/**
 * Get Location Attached Forms
 */
export const glacierPolicyFormsApiGetLocationAttachedFormsOptions = (
  options: Options<GlacierPolicyFormsApiGetLocationAttachedFormsData>
) =>
  queryOptions<
    GlacierPolicyFormsApiGetLocationAttachedFormsResponse,
    DefaultError,
    GlacierPolicyFormsApiGetLocationAttachedFormsResponse,
    ReturnType<typeof glacierPolicyFormsApiGetLocationAttachedFormsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetLocationAttachedForms({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetLocationAttachedFormsQueryKey(options),
  });

export const glacierPolicyFormsApiGetLocationAvailableEndorsementsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetLocationAvailableEndorsementsData>
) =>
  createQueryKey(
    'glacierPolicyFormsApiGetLocationAvailableEndorsements',
    options
  );

/**
 * Get Location Available Endorsements
 */
export const glacierPolicyFormsApiGetLocationAvailableEndorsementsOptions = (
  options: Options<GlacierPolicyFormsApiGetLocationAvailableEndorsementsData>
) =>
  queryOptions<
    GlacierPolicyFormsApiGetLocationAvailableEndorsementsResponse,
    DefaultError,
    GlacierPolicyFormsApiGetLocationAvailableEndorsementsResponse,
    ReturnType<
      typeof glacierPolicyFormsApiGetLocationAvailableEndorsementsQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyFormsApiGetLocationAvailableEndorsements({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyFormsApiGetLocationAvailableEndorsementsQueryKey(options),
  });

/**
 * Attach Form To Entity
 */
export const glacierPolicyFormsApiAttachFormToEntityMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiAttachFormToEntityData>>
): UseMutationOptions<
  GlacierPolicyFormsApiAttachFormToEntityResponse,
  DefaultError,
  Options<GlacierPolicyFormsApiAttachFormToEntityData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiAttachFormToEntityResponse,
    DefaultError,
    Options<GlacierPolicyFormsApiAttachFormToEntityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyFormsApiAttachFormToEntity({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Detach Form From Entity
 */
export const glacierPolicyFormsApiDetachFormFromEntityMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiDetachFormFromEntityData>>
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyFormsApiDetachFormFromEntityData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyFormsApiDetachFormFromEntityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyFormsApiDetachFormFromEntity({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetEntityAttachedFormsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetEntityAttachedFormsData>
) => createQueryKey('glacierPolicyFormsApiGetEntityAttachedForms', options);

/**
 * Get Entity Attached Forms
 */
export const glacierPolicyFormsApiGetEntityAttachedFormsOptions = (
  options: Options<GlacierPolicyFormsApiGetEntityAttachedFormsData>
) =>
  queryOptions<
    GlacierPolicyFormsApiGetEntityAttachedFormsResponse,
    DefaultError,
    GlacierPolicyFormsApiGetEntityAttachedFormsResponse,
    ReturnType<typeof glacierPolicyFormsApiGetEntityAttachedFormsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetEntityAttachedForms({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetEntityAttachedFormsQueryKey(options),
  });

export const glacierPolicyFormsApiGetEntityAvailableEndorsementsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetEntityAvailableEndorsementsData>
) =>
  createQueryKey(
    'glacierPolicyFormsApiGetEntityAvailableEndorsements',
    options
  );

/**
 * Get Entity Available Endorsements
 */
export const glacierPolicyFormsApiGetEntityAvailableEndorsementsOptions = (
  options: Options<GlacierPolicyFormsApiGetEntityAvailableEndorsementsData>
) =>
  queryOptions<
    GlacierPolicyFormsApiGetEntityAvailableEndorsementsResponse,
    DefaultError,
    GlacierPolicyFormsApiGetEntityAvailableEndorsementsResponse,
    ReturnType<
      typeof glacierPolicyFormsApiGetEntityAvailableEndorsementsQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyFormsApiGetEntityAvailableEndorsements({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyFormsApiGetEntityAvailableEndorsementsQueryKey(options),
  });

/**
 * Render Form
 *
 * Render a form to PDF
 *
 * If a sequence_id is provided here outside of time travel mode,
 * it will load the policy version from the repository.
 */
export const glacierPolicyFormsApiRenderFormMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiRenderFormData>>
): UseMutationOptions<
  GlacierPolicyFormsApiRenderFormResponse,
  DefaultError,
  Options<GlacierPolicyFormsApiRenderFormData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiRenderFormResponse,
    DefaultError,
    Options<GlacierPolicyFormsApiRenderFormData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyFormsApiRenderForm({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetQuestionsByPolicyQueryKey = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByPolicyData>
) => createQueryKey('glacierPolicyFormsApiGetQuestionsByPolicy', options);

/**
 * Get Questions By Policy
 */
export const glacierPolicyFormsApiGetQuestionsByPolicyOptions = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByPolicyData>
) =>
  queryOptions<
    GlacierPolicyFormsApiGetQuestionsByPolicyResponse,
    DefaultError,
    GlacierPolicyFormsApiGetQuestionsByPolicyResponse,
    ReturnType<typeof glacierPolicyFormsApiGetQuestionsByPolicyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetQuestionsByPolicy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetQuestionsByPolicyQueryKey(options),
  });

/**
 * Post Save Questions Answers Policy
 */
export const glacierPolicyFormsApiPostSaveQuestionsAnswersPolicyMutation = (
  options?: Partial<
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData>
  >
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await glacierPolicyFormsApiPostSaveQuestionsAnswersPolicy({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetQuestionsByDentistQueryKey = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByDentistData>
) => createQueryKey('glacierPolicyFormsApiGetQuestionsByDentist', options);

/**
 * Get Questions By Dentist
 */
export const glacierPolicyFormsApiGetQuestionsByDentistOptions = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByDentistData>
) =>
  queryOptions<
    GlacierPolicyFormsApiGetQuestionsByDentistResponse,
    DefaultError,
    GlacierPolicyFormsApiGetQuestionsByDentistResponse,
    ReturnType<typeof glacierPolicyFormsApiGetQuestionsByDentistQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetQuestionsByDentist({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetQuestionsByDentistQueryKey(options),
  });

/**
 * Post Save Questions Answers Dentist
 */
export const glacierPolicyFormsApiPostSaveQuestionsAnswersDentistMutation = (
  options?: Partial<
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData>
  >
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await glacierPolicyFormsApiPostSaveQuestionsAnswersDentist({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetQuestionsByLocationQueryKey = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByLocationData>
) => createQueryKey('glacierPolicyFormsApiGetQuestionsByLocation', options);

/**
 * Get Questions By Location
 */
export const glacierPolicyFormsApiGetQuestionsByLocationOptions = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByLocationData>
) =>
  queryOptions<
    GlacierPolicyFormsApiGetQuestionsByLocationResponse,
    DefaultError,
    GlacierPolicyFormsApiGetQuestionsByLocationResponse,
    ReturnType<typeof glacierPolicyFormsApiGetQuestionsByLocationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetQuestionsByLocation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetQuestionsByLocationQueryKey(options),
  });

/**
 * Post Save Questions Answers Location
 */
export const glacierPolicyFormsApiPostSaveQuestionsAnswersLocationMutation = (
  options?: Partial<
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData>
  >
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await glacierPolicyFormsApiPostSaveQuestionsAnswersLocation({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetQuestionsByEntityQueryKey = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByEntityData>
) => createQueryKey('glacierPolicyFormsApiGetQuestionsByEntity', options);

/**
 * Get Questions By Entity
 */
export const glacierPolicyFormsApiGetQuestionsByEntityOptions = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByEntityData>
) =>
  queryOptions<
    GlacierPolicyFormsApiGetQuestionsByEntityResponse,
    DefaultError,
    GlacierPolicyFormsApiGetQuestionsByEntityResponse,
    ReturnType<typeof glacierPolicyFormsApiGetQuestionsByEntityQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetQuestionsByEntity({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetQuestionsByEntityQueryKey(options),
  });

/**
 * Post Save Questions Answers Entity
 */
export const glacierPolicyFormsApiPostSaveQuestionsAnswersEntityMutation = (
  options?: Partial<
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData>
  >
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await glacierPolicyFormsApiPostSaveQuestionsAnswersEntity({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyConditionsApiListBindingConditionsQueryKey = (
  options: Options<GlacierPolicyConditionsApiListBindingConditionsData>
) => createQueryKey('glacierPolicyConditionsApiListBindingConditions', options);

/**
 * List Binding Conditions
 */
export const glacierPolicyConditionsApiListBindingConditionsOptions = (
  options: Options<GlacierPolicyConditionsApiListBindingConditionsData>
) =>
  queryOptions<
    GlacierPolicyConditionsApiListBindingConditionsResponse,
    DefaultError,
    GlacierPolicyConditionsApiListBindingConditionsResponse,
    ReturnType<typeof glacierPolicyConditionsApiListBindingConditionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyConditionsApiListBindingConditions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyConditionsApiListBindingConditionsQueryKey(options),
  });

/**
 * Create Binding Condition
 */
export const glacierPolicyConditionsApiCreateBindingConditionMutation = (
  options?: Partial<
    Options<GlacierPolicyConditionsApiCreateBindingConditionData>
  >
): UseMutationOptions<
  GlacierPolicyConditionsApiCreateBindingConditionResponse,
  DefaultError,
  Options<GlacierPolicyConditionsApiCreateBindingConditionData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyConditionsApiCreateBindingConditionResponse,
    DefaultError,
    Options<GlacierPolicyConditionsApiCreateBindingConditionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyConditionsApiCreateBindingCondition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Binding Condition
 */
export const glacierPolicyConditionsApiDeleteBindingConditionMutation = (
  options?: Partial<
    Options<GlacierPolicyConditionsApiDeleteBindingConditionData>
  >
): UseMutationOptions<
  GlacierPolicyConditionsApiDeleteBindingConditionResponse,
  DefaultError,
  Options<GlacierPolicyConditionsApiDeleteBindingConditionData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyConditionsApiDeleteBindingConditionResponse,
    DefaultError,
    Options<GlacierPolicyConditionsApiDeleteBindingConditionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyConditionsApiDeleteBindingCondition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Binding Condition
 */
export const glacierPolicyConditionsApiUpdateBindingConditionMutation = (
  options?: Partial<
    Options<GlacierPolicyConditionsApiUpdateBindingConditionData>
  >
): UseMutationOptions<
  GlacierPolicyConditionsApiUpdateBindingConditionResponse,
  DefaultError,
  Options<GlacierPolicyConditionsApiUpdateBindingConditionData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyConditionsApiUpdateBindingConditionResponse,
    DefaultError,
    Options<GlacierPolicyConditionsApiUpdateBindingConditionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyConditionsApiUpdateBindingCondition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyConditionsApiListTermsConditionsQueryKey = (
  options: Options<GlacierPolicyConditionsApiListTermsConditionsData>
) => createQueryKey('glacierPolicyConditionsApiListTermsConditions', options);

/**
 * List Terms Conditions
 */
export const glacierPolicyConditionsApiListTermsConditionsOptions = (
  options: Options<GlacierPolicyConditionsApiListTermsConditionsData>
) =>
  queryOptions<
    GlacierPolicyConditionsApiListTermsConditionsResponse,
    DefaultError,
    GlacierPolicyConditionsApiListTermsConditionsResponse,
    ReturnType<typeof glacierPolicyConditionsApiListTermsConditionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyConditionsApiListTermsConditions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyConditionsApiListTermsConditionsQueryKey(options),
  });

/**
 * Create Terms Condition
 */
export const glacierPolicyConditionsApiCreateTermsConditionMutation = (
  options?: Partial<Options<GlacierPolicyConditionsApiCreateTermsConditionData>>
): UseMutationOptions<
  GlacierPolicyConditionsApiCreateTermsConditionResponse,
  DefaultError,
  Options<GlacierPolicyConditionsApiCreateTermsConditionData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyConditionsApiCreateTermsConditionResponse,
    DefaultError,
    Options<GlacierPolicyConditionsApiCreateTermsConditionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyConditionsApiCreateTermsCondition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Terms Condition
 */
export const glacierPolicyConditionsApiDeleteTermsConditionMutation = (
  options?: Partial<Options<GlacierPolicyConditionsApiDeleteTermsConditionData>>
): UseMutationOptions<
  GlacierPolicyConditionsApiDeleteTermsConditionResponse,
  DefaultError,
  Options<GlacierPolicyConditionsApiDeleteTermsConditionData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyConditionsApiDeleteTermsConditionResponse,
    DefaultError,
    Options<GlacierPolicyConditionsApiDeleteTermsConditionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyConditionsApiDeleteTermsCondition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Terms Condition
 */
export const glacierPolicyConditionsApiUpdateTermsConditionMutation = (
  options?: Partial<Options<GlacierPolicyConditionsApiUpdateTermsConditionData>>
): UseMutationOptions<
  GlacierPolicyConditionsApiUpdateTermsConditionResponse,
  DefaultError,
  Options<GlacierPolicyConditionsApiUpdateTermsConditionData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyConditionsApiUpdateTermsConditionResponse,
    DefaultError,
    Options<GlacierPolicyConditionsApiUpdateTermsConditionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyConditionsApiUpdateTermsCondition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyErpApiGetErpEligibleDatesQueryKey = (
  options: Options<GlacierPolicyErpApiGetErpEligibleDatesData>
) => createQueryKey('glacierPolicyErpApiGetErpEligibleDates', options);

/**
 * Get Erp Eligible Dates
 *
 * Return Valid Effective Dates for ERP (Extended Reporting Period)
 */
export const glacierPolicyErpApiGetErpEligibleDatesOptions = (
  options: Options<GlacierPolicyErpApiGetErpEligibleDatesData>
) =>
  queryOptions<
    GlacierPolicyErpApiGetErpEligibleDatesResponse,
    DefaultError,
    GlacierPolicyErpApiGetErpEligibleDatesResponse,
    ReturnType<typeof glacierPolicyErpApiGetErpEligibleDatesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyErpApiGetErpEligibleDates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyErpApiGetErpEligibleDatesQueryKey(options),
  });

export const glacierPolicyErpApiGetErpSectionsQueryKey = (
  options: Options<GlacierPolicyErpApiGetErpSectionsData>
) => createQueryKey('glacierPolicyErpApiGetErpSections', options);

/**
 * Get Erp Sections
 *
 * Returns an array of ErpSection objects for the policy's active ERP In Progress transaction.
 */
export const glacierPolicyErpApiGetErpSectionsOptions = (
  options: Options<GlacierPolicyErpApiGetErpSectionsData>
) =>
  queryOptions<
    GlacierPolicyErpApiGetErpSectionsResponse,
    DefaultError,
    GlacierPolicyErpApiGetErpSectionsResponse,
    ReturnType<typeof glacierPolicyErpApiGetErpSectionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyErpApiGetErpSections({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyErpApiGetErpSectionsQueryKey(options),
  });

/**
 * Start Erp Endorsement
 *
 * Start ERP Endorsement Transaction
 */
export const glacierPolicyErpApiStartErpEndorsementMutation = (
  options?: Partial<Options<GlacierPolicyErpApiStartErpEndorsementData>>
): UseMutationOptions<
  GlacierPolicyErpApiStartErpEndorsementResponse,
  DefaultError,
  Options<GlacierPolicyErpApiStartErpEndorsementData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyErpApiStartErpEndorsementResponse,
    DefaultError,
    Options<GlacierPolicyErpApiStartErpEndorsementData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyErpApiStartErpEndorsement({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Save Erp Selections
 *
 * Save ERP selections for the policy's active ERP In Progress transaction.
 */
export const glacierPolicyErpApiSaveErpSelectionsMutation = (
  options?: Partial<Options<GlacierPolicyErpApiSaveErpSelectionsData>>
): UseMutationOptions<
  GlacierPolicyErpApiSaveErpSelectionsResponse,
  DefaultError,
  Options<GlacierPolicyErpApiSaveErpSelectionsData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyErpApiSaveErpSelectionsResponse,
    DefaultError,
    Options<GlacierPolicyErpApiSaveErpSelectionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyErpApiSaveErpSelections({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Copy Policy Endpoint
 *
 * Copy a quote into a new quote via the clone engine.
 *
 * ``@read_only_operation``: copying reads the source account (the new
 * policy is a separate aggregate), so tenancy uses read scope --
 * underwriters may copy any policy they can access while agents stay
 * limited to their own agency (403 cross-agency, enforced by
 * ``AuthenticateAndAccessAccountPermission``).
 */
export const glacierPolicyCloneApiCopyPolicyEndpointMutation = (
  options?: Partial<Options<GlacierPolicyCloneApiCopyPolicyEndpointData>>
): UseMutationOptions<
  GlacierPolicyCloneApiCopyPolicyEndpointResponse,
  DefaultError,
  Options<GlacierPolicyCloneApiCopyPolicyEndpointData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyCloneApiCopyPolicyEndpointResponse,
    DefaultError,
    Options<GlacierPolicyCloneApiCopyPolicyEndpointData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierPolicyCloneApiCopyPolicyEndpoint({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierOneschemaApiGetJwtTokenQueryKey = (
  options?: Options<GlacierOneschemaApiGetJwtTokenData>
) => createQueryKey('glacierOneschemaApiGetJwtToken', options);

/**
 * Get Jwt Token
 *
 * OneSchema requires use of JWT tokens for requests. This returns a token that
 * the frontend can use when initializing the Importer.
 *
 * https://docs.oneschema.co/docs/generating-jwts
 */
export const glacierOneschemaApiGetJwtTokenOptions = (
  options?: Options<GlacierOneschemaApiGetJwtTokenData>
) =>
  queryOptions<
    GlacierOneschemaApiGetJwtTokenResponse,
    GlacierOneschemaApiGetJwtTokenError,
    GlacierOneschemaApiGetJwtTokenResponse,
    ReturnType<typeof glacierOneschemaApiGetJwtTokenQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierOneschemaApiGetJwtToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierOneschemaApiGetJwtTokenQueryKey(options),
  });

/**
 * Bulk Upload Policies
 */
export const glacierOneschemaApiBulkUploadPoliciesMutation = (
  options?: Partial<Options<GlacierOneschemaApiBulkUploadPoliciesData>>
): UseMutationOptions<
  GlacierOneschemaApiBulkUploadPoliciesResponse,
  GlacierOneschemaApiBulkUploadPoliciesError,
  Options<GlacierOneschemaApiBulkUploadPoliciesData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierOneschemaApiBulkUploadPoliciesResponse,
    GlacierOneschemaApiBulkUploadPoliciesError,
    Options<GlacierOneschemaApiBulkUploadPoliciesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierOneschemaApiBulkUploadPolicies({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Upload Dentists
 *
 * Performs a bulk import via data passed by OneSchema. The import
 * is controlled by the template key provided in the payload
 */
export const glacierOneschemaApiBulkUploadDentistsMutation = (
  options?: Partial<Options<GlacierOneschemaApiBulkUploadDentistsData>>
): UseMutationOptions<
  GlacierOneschemaApiBulkUploadDentistsResponse,
  GlacierOneschemaApiBulkUploadDentistsError,
  Options<GlacierOneschemaApiBulkUploadDentistsData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierOneschemaApiBulkUploadDentistsResponse,
    GlacierOneschemaApiBulkUploadDentistsError,
    Options<GlacierOneschemaApiBulkUploadDentistsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierOneschemaApiBulkUploadDentists({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Upload Locations
 *
 * Performs a bulk import via data passed by OneSchema. The import
 * is controlled by the template key provided in the payload
 */
export const glacierOneschemaApiBulkUploadLocationsMutation = (
  options?: Partial<Options<GlacierOneschemaApiBulkUploadLocationsData>>
): UseMutationOptions<
  GlacierOneschemaApiBulkUploadLocationsResponse,
  GlacierOneschemaApiBulkUploadLocationsError,
  Options<GlacierOneschemaApiBulkUploadLocationsData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierOneschemaApiBulkUploadLocationsResponse,
    GlacierOneschemaApiBulkUploadLocationsError,
    Options<GlacierOneschemaApiBulkUploadLocationsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierOneschemaApiBulkUploadLocations({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierAgenciesApiListWritingCompanyQueryKey = (
  options?: Options<GlacierAgenciesApiListWritingCompanyData>
) => createQueryKey('glacierAgenciesApiListWritingCompany', options);

/**
 * List Writing Company
 *
 * List writing company details
 */
export const glacierAgenciesApiListWritingCompanyOptions = (
  options?: Options<GlacierAgenciesApiListWritingCompanyData>
) =>
  queryOptions<
    GlacierAgenciesApiListWritingCompanyResponse,
    DefaultError,
    GlacierAgenciesApiListWritingCompanyResponse,
    ReturnType<typeof glacierAgenciesApiListWritingCompanyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierAgenciesApiListWritingCompany({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierAgenciesApiListWritingCompanyQueryKey(options),
  });

/**
 * Validate Agency
 *
 * Validate the agency.
 */
export const glacierNewGradApiValidateAgencyMutation = (
  options?: Partial<Options<GlacierNewGradApiValidateAgencyData>>
): UseMutationOptions<
  GlacierNewGradApiValidateAgencyResponse,
  GlacierNewGradApiValidateAgencyError,
  Options<GlacierNewGradApiValidateAgencyData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierNewGradApiValidateAgencyResponse,
    GlacierNewGradApiValidateAgencyError,
    Options<GlacierNewGradApiValidateAgencyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierNewGradApiValidateAgency({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Validate Association Code
 */
export const glacierNewGradApiValidateAssociationCodeMutation = (
  options?: Partial<Options<GlacierNewGradApiValidateAssociationCodeData>>
): UseMutationOptions<
  GlacierNewGradApiValidateAssociationCodeResponse,
  GlacierNewGradApiValidateAssociationCodeError,
  Options<GlacierNewGradApiValidateAssociationCodeData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierNewGradApiValidateAssociationCodeResponse,
    GlacierNewGradApiValidateAssociationCodeError,
    Options<GlacierNewGradApiValidateAssociationCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierNewGradApiValidateAssociationCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Save Answers
 *
 * Save the answers.
 */
export const glacierNewGradApiSaveAnswersMutation = (
  options?: Partial<Options<GlacierNewGradApiSaveAnswersData>>
): UseMutationOptions<
  GlacierNewGradApiSaveAnswersResponse,
  GlacierNewGradApiSaveAnswersError,
  Options<GlacierNewGradApiSaveAnswersData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierNewGradApiSaveAnswersResponse,
    GlacierNewGradApiSaveAnswersError,
    Options<GlacierNewGradApiSaveAnswersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierNewGradApiSaveAnswers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Issue Policy
 *
 * Handles the issuance of a new policy for a specified account.
 */
export const glacierNewGradApiIssuePolicyMutation = (
  options?: Partial<Options<GlacierNewGradApiIssuePolicyData>>
): UseMutationOptions<
  GlacierNewGradApiIssuePolicyResponse,
  GlacierNewGradApiIssuePolicyError,
  Options<GlacierNewGradApiIssuePolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierNewGradApiIssuePolicyResponse,
    GlacierNewGradApiIssuePolicyError,
    Options<GlacierNewGradApiIssuePolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierNewGradApiIssuePolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierNewGradApiGetAnswersQueryKey = (
  options: Options<GlacierNewGradApiGetAnswersData>
) => createQueryKey('glacierNewGradApiGetAnswers', options);

/**
 * Get Answers
 *
 * Get the answers.
 */
export const glacierNewGradApiGetAnswersOptions = (
  options: Options<GlacierNewGradApiGetAnswersData>
) =>
  queryOptions<
    GlacierNewGradApiGetAnswersResponse,
    DefaultError,
    GlacierNewGradApiGetAnswersResponse,
    ReturnType<typeof glacierNewGradApiGetAnswersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierNewGradApiGetAnswers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierNewGradApiGetAnswersQueryKey(options),
  });

/**
 * Poll Payment
 *
 * Poll the payment status.
 */
export const glacierNewGradApiPollPaymentMutation = (
  options?: Partial<Options<GlacierNewGradApiPollPaymentData>>
): UseMutationOptions<
  GlacierNewGradApiPollPaymentResponse,
  DefaultError,
  Options<GlacierNewGradApiPollPaymentData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierNewGradApiPollPaymentResponse,
    DefaultError,
    Options<GlacierNewGradApiPollPaymentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierNewGradApiPollPayment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Download Quote
 *
 * Download the quote.
 */
export const glacierNewGradApiDownloadQuoteMutation = (
  options?: Partial<Options<GlacierNewGradApiDownloadQuoteData>>
): UseMutationOptions<
  GlacierNewGradApiDownloadQuoteResponse,
  DefaultError,
  Options<GlacierNewGradApiDownloadQuoteData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierNewGradApiDownloadQuoteResponse,
    DefaultError,
    Options<GlacierNewGradApiDownloadQuoteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierNewGradApiDownloadQuote({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Download Policy
 *
 * Download the policy.
 */
export const glacierNewGradApiDownloadPolicyMutation = (
  options?: Partial<Options<GlacierNewGradApiDownloadPolicyData>>
): UseMutationOptions<
  GlacierNewGradApiDownloadPolicyResponse,
  DefaultError,
  Options<GlacierNewGradApiDownloadPolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierNewGradApiDownloadPolicyResponse,
    DefaultError,
    Options<GlacierNewGradApiDownloadPolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierNewGradApiDownloadPolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Mark Payment As Paid
 *
 * Mark the payment as paid by updating the paid_at timestamp.
 * This will trigger the policy issuance process via the PaymentResponse signal handler.
 */
export const glacierNewGradApiMarkPaymentAsPaidMutation = (
  options?: Partial<Options<GlacierNewGradApiMarkPaymentAsPaidData>>
): UseMutationOptions<
  GlacierNewGradApiMarkPaymentAsPaidResponse,
  DefaultError,
  Options<GlacierNewGradApiMarkPaymentAsPaidData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierNewGradApiMarkPaymentAsPaidResponse,
    DefaultError,
    Options<GlacierNewGradApiMarkPaymentAsPaidData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierNewGradApiMarkPaymentAsPaid({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Mfa Verify
 *
 * Complete the email-OTP MFA challenge for the headless (SPA) login flow.
 *
 * Compares the submitted ``body.token`` against the cached OTP for
 * ``body.user_id``. On a match the token is consumed, the user is logged in,
 * and the shared ``mfa_verified`` cookie is minted so every surface treats
 * MFA as satisfied. Rate-limited per IP and per ``user_id`` (see the
 * ``throttle`` decorator) to bound brute-force of the OTP.
 *
 * Args:
 * request: The incoming request; the user is anonymous until the OTP
 * matches, at which point ``adapter.login`` establishes the session.
 * body: Validated payload carrying the 6-digit ``token`` and target
 * ``user_id``.
 *
 * Returns:
 * A ``CustomJsonResponse`` with HTTP 200 and a success message when the
 * OTP is valid; otherwise HTTP 400 with ``"Invalid or expired token"``
 * (bad/expired token) or ``"User not found"`` (unknown ``user_id``).
 */
export const glacierAuthenticationApiMfaVerifyMutation = (
  options?: Partial<Options<GlacierAuthenticationApiMfaVerifyData>>
): UseMutationOptions<
  GlacierAuthenticationApiMfaVerifyResponse,
  DefaultError,
  Options<GlacierAuthenticationApiMfaVerifyData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierAuthenticationApiMfaVerifyResponse,
    DefaultError,
    Options<GlacierAuthenticationApiMfaVerifyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierAuthenticationApiMfaVerify({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierAssistantApiAssistantConfigQueryKey = (
  options?: Options<GlacierAssistantApiAssistantConfigData>
) => createQueryKey('glacierAssistantApiAssistantConfig', options);

/**
 * Assistant Config
 */
export const glacierAssistantApiAssistantConfigOptions = (
  options?: Options<GlacierAssistantApiAssistantConfigData>
) =>
  queryOptions<
    GlacierAssistantApiAssistantConfigResponse,
    DefaultError,
    GlacierAssistantApiAssistantConfigResponse,
    ReturnType<typeof glacierAssistantApiAssistantConfigQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierAssistantApiAssistantConfig({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierAssistantApiAssistantConfigQueryKey(options),
  });

/**
 * Chat
 */
export const glacierAssistantApiChatMutation = (
  options?: Partial<Options<GlacierAssistantApiChatData>>
): UseMutationOptions<
  GlacierAssistantApiChatResponse,
  DefaultError,
  Options<GlacierAssistantApiChatData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierAssistantApiChatResponse,
    DefaultError,
    Options<GlacierAssistantApiChatData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierAssistantApiChat({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Submit Feedback
 */
export const glacierAssistantApiSubmitFeedbackMutation = (
  options?: Partial<Options<GlacierAssistantApiSubmitFeedbackData>>
): UseMutationOptions<
  GlacierAssistantApiSubmitFeedbackResponse,
  DefaultError,
  Options<GlacierAssistantApiSubmitFeedbackData>
> => {
  const mutationOptions: UseMutationOptions<
    GlacierAssistantApiSubmitFeedbackResponse,
    DefaultError,
    Options<GlacierAssistantApiSubmitFeedbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await glacierAssistantApiSubmitFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
